/* ZMZM Labs — onboarding + PDP sheet bootstrap (extracted from snippets/zmzm-overrides.liquid May 5, 2026) */

 // Scroll-reveal: add .zmzm-revealed when target sections enter viewport
 (function () {
 if (typeof IntersectionObserver === 'undefined') return;
 var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if (prefersReduced) return;

 var SELECTOR = '.zmzm-fade-on-scroll';

 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (entry) {
 if (entry.isIntersecting) {
 entry.target.classList.add('zmzm-revealed');
 io.unobserve(entry.target);
 }
 });
 }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

 function mount() {
 document.querySelectorAll(SELECTOR).forEach(function (el) {
 // If already in view at page load, reveal immediately (no flash)
 var r = el.getBoundingClientRect();
 if (r.top < window.innerHeight && r.bottom > 0) {
 el.classList.add('zmzm-revealed');
 } else {
 io.observe(el);
 }
 });
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', mount);
 } else {
 mount();
 }
 })();

 // Sanctuary Lab — inject lab-notation corners into hero
 (function () {
 function injectHeroCorners() {
 var hero = document.querySelector('.image-banner__media, [class*="image-banner"] [class*="media"]');
 if (!hero || hero.querySelector('.zmzm-hero-corner')) return;
 var heroSection = hero.closest('.image-banner, [class*="shopify-section"]');
 if (!heroSection) return;
 // Make sure parent is positioned for absolute children
 if (getComputedStyle(heroSection).position === 'static') {
 heroSection.style.position = 'relative';
 }
 var left = document.createElement('div');
 left.className = 'zmzm-hero-corner zmzm-hero-corner--left';
 left.textContent = 'sanctuary lab — 001';
 var right = document.createElement('div');
 right.className = 'zmzm-hero-corner zmzm-hero-corner--right';
 right.textContent = 'mmxxvi';
 heroSection.appendChild(left);
 heroSection.appendChild(right);
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', injectHeroCorners);
 } else {
 injectHeroCorners();
 }
 })();

(function () {
 if (window.__zmzmAppFlowInit) return;
 window.__zmzmAppFlowInit = true;

 var isMobile = function () { return window.innerWidth <= 768; };

 // ============================================================
 // Cart → Checkout ceremonial transition (Aman pacing, 600ms)
 // Wraps the checkout button click; shows a fade overlay then redirects.
 // ============================================================
 (function checkoutTransition() {
 function makeOverlay() {
 var ov = document.createElement('div');
 ov.className = 'zmzm-checkout-fade';
 ov.innerHTML =
 '<div class="zmzm-checkout-fade__rule"></div>' +
 '<div class="zmzm-checkout-fade__tag">— preparing your order</div>' +
 '<div class="zmzm-checkout-fade__line">this takes a moment.</div>';
 return ov;
 }

 function attach() {
 var btns = document.querySelectorAll(
 '.cart-drawer-subtotal__btn, button[name="checkout"], a[href="/checkout"], a[href*="/checkouts/"]'
 );
 btns.forEach(function (btn) {
 if (btn.dataset.zmzmWrapped === '1') return;
 btn.dataset.zmzmWrapped = '1';
 btn.addEventListener('click', function (e) {
 if (e.__zmzmHandled) return;
 // Don't intercept Shop Pay / Apple Pay / Google Pay (those vendors own the redirect)
 if (btn.closest('.shopify-payment-button')) return;
 e.preventDefault();

 // Pass quiz dimensions to Klaviyo as anonymous profile properties so
 // they stitch onto the customer record at checkout email entry.
 // Lets cart-abandonment emails be properly segmented by quiz answers.
 try {
 if (window.klaviyo && typeof window.klaviyo.push === 'function') {
 var quizProps = { entered_checkout_at: new Date().toISOString() };
 ['segment','goal','rhythm','depth','tier','truth','standard','engagement'].forEach(function (k) {
 var v = '';
 try { v = sessionStorage.getItem('zmzm_quiz_' + k) || ''; } catch (er) {}
 if (v) quizProps['quiz_' + k] = v;
 });
 window.klaviyo.push(['identify', quizProps]);
 window.klaviyo.push(['track', 'Checkout Initiated — Quiz Segment', quizProps]);
 }
 } catch (er) {}

 var ov = makeOverlay();
 document.body.appendChild(ov);
 requestAnimationFrame(function () { ov.classList.add('is-visible'); });

 setTimeout(function () {
 // Allow native click to proceed
 if (btn.tagName === 'A' && btn.href) {
 window.location.href = btn.href;
 return;
 }
 // For form buttons, find the parent form and submit
 var form = btn.closest('form');
 if (form) {
 form.submit();
 return;
 }
 // Fallback: re-fire click marked as handled
 var ev = new MouseEvent('click', { bubbles: true, cancelable: true });
 ev.__zmzmHandled = true;
 btn.dispatchEvent(ev);
 }, 620);
 }, true);
 });
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', attach);
 } else {
 attach();
 }
 // Cart drawer renders dynamically — re-attach when items change
 var mo = new MutationObserver(function () { attach(); });
 mo.observe(document.body, { childList: true, subtree: true });
 })();

 // ============================================================
 // Account dashboard "your routine" personalization card
 // Injects a Sanctuary Lab card at the top of /account showing the user's
 // quiz segment + goal + rhythm if known.
 // ============================================================
 (function accountRoutineCard() {
 try {
 if (window.location.pathname.indexOf('/account') !== 0) return;
 if (window.location.pathname.indexOf('/account/') === 0 &&
 !/\/account\/?$/.test(window.location.pathname)) return; // dashboard root only

 var goal = sessionStorage.getItem('zmzm_quiz_goal') || '';
 var rhythm = sessionStorage.getItem('zmzm_quiz_rhythm') || '';
 var segment = sessionStorage.getItem('zmzm_quiz_segment') || '';
 var hasQuiz = !!(goal || rhythm);

 function inject() {
 var main = document.querySelector('main, [class*="customer__page"], [class*="account"]');
 if (!main || document.querySelector('.zmzm-account-card')) return;

 var card = document.createElement('div');
 card.className = 'zmzm-account-card';
 if (hasQuiz) {
 card.innerHTML =
 '<div class="zmzm-account-card__tag">— your routine</div>' +
 '<h2 class="zmzm-account-card__title">' +
 (goal ? 'your <em>' + goal + '</em> stack' : 'your routine') +
 (rhythm ? ' · <em>' + rhythm + '</em> window' : '') +
 '</h2>' +
 '<p class="zmzm-account-card__sub">' +
 (segment === 'halal'
 ? 'aligned to the rhythm you already live.'
 : 'matched against twelve thousand ingredient datapoints.') +
 '</p>' +
 '<a class="zmzm-account-card__cta" href="/collections/the-barakah-schedule">continue your rhythm →</a>';
 } else {
 card.innerHTML =
 '<div class="zmzm-account-card__tag">— your sanctuary brief</div>' +
 '<h2 class="zmzm-account-card__title">build your routine in 90 seconds.</h2>' +
 '<p class="zmzm-account-card__sub">five questions. a stack composed for who you actually are.</p>' +
 '<a class="zmzm-account-card__cta" href="/pages/barakah-quiz">begin the brief →</a>';
 }
 main.insertBefore(card, main.firstChild);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', inject);
 } else {
 inject();
 }
 setTimeout(inject, 600);
 } catch (e) {}
 })();

 // ============================================================
 // FIX 2b — Rhythm timeline tap-to-expand
 // ============================================================
 (function rhythmTapExpand() {
 try {
 function attach() {
 var entries = document.querySelectorAll('[class*="zrt-entry"]');
 entries.forEach(function (entry) {
 if (entry.dataset.zmzmExpandWired === '1') return;
 entry.dataset.zmzmExpandWired = '1';
 var content = entry.querySelector('[class*="zrt-content"]');
 if (!content) return;
 // Auto-expand the live prayer entry
 if (entry.classList.contains('zrt-entry--live')) {
 entry.classList.add('zrt-entry--expanded');
 }
 content.addEventListener('click', function (e) {
 // Don't toggle when tapping the explore link itself
 if (e.target.closest('[class*="zrt-link"]')) return;
 entry.classList.toggle('zrt-entry--expanded');
 });
 // Make keyboard-accessible
 content.setAttribute('role', 'button');
 content.setAttribute('tabindex', '0');
 content.addEventListener('keydown', function (e) {
 if (e.key === 'Enter' || e.key === ' ') {
 e.preventDefault();
 entry.classList.toggle('zrt-entry--expanded');
 }
 });
 });
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', attach);
 } else {
 attach();
 }
 setTimeout(attach, 600);
 } catch (e) {}
 })();

 // ============================================================
 // FIX 2 — Rhythm timeline live prayer indicator
 // Highlights the currently-active prayer window based on local time.
 // ============================================================
 (function rhythmLiveIndicator() {
 try {
 var entries = document.querySelectorAll('[class*="zrt-entry"]');
 if (!entries.length) return;

 var WINDOWS = [
 { key:'fajr', start: 4.5, end: 6.0, label:'fajr' },
 { key:'dhuhr', start: 12.0, end: 15.0, label:'dhuhr' },
 { key:'asr', start: 15.0, end: 18.5, label:'asr' },
 { key:'maghrib', start: 18.5, end: 20.0, label:'maghrib' },
 { key:'isha', start: 20.0, end: 28.5, label:'isha' }
 ];

 function update() {
 var now = new Date();
 var h = now.getHours() + now.getMinutes() / 60;
 var hWrap = (h < 4.5) ? h + 24 : h;
 var liveKey = null;
 WINDOWS.forEach(function (w) {
 if (hWrap >= w.start && hWrap < w.end) liveKey = w.key;
 });
 entries.forEach(function (e) {
 var label = (e.textContent || '').toLowerCase();
 var isMatch = liveKey && label.indexOf(liveKey) !== -1;
 // Make sure entry is positioned for the ::after pseudo-element
 if (isMatch) {
 if (getComputedStyle(e).position === 'static') e.style.position = 'relative';
 e.classList.add('zrt-entry--live');
 } else {
 e.classList.remove('zrt-entry--live');
 }
 });
 }
 update();
 // Refresh every 5 minutes — prayer windows shift
 setInterval(update, 5 * 60 * 1000);
 } catch (e) {}
 })();

 // ============================================================
 // FIX 3 — Us-vs-Them rows · IO-driven reveal for icons
 // ============================================================
 (function uvtReveal() {
 try {
 if (!('IntersectionObserver' in window)) return;
 if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
 var rows = document.querySelectorAll('[id^="zuvt-"] [class*="zuvt-row"]');
 if (!rows.length) return;
 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (entry) {
 if (entry.isIntersecting) {
 entry.target.classList.add('is-revealed');
 io.unobserve(entry.target);
 }
 });
 }, { threshold: 0.25 });
 rows.forEach(function (r) { io.observe(r); });
 } catch (e) {}
 })();

 // ============================================================
 // FIX 4 — Replace COA mailto with order-number-gated form
 // Reduces spam from non-customers; channels real customers
 // through a structured Klaviyo event.
 // ============================================================
 (function coaFormReplace() {
 try {
 function inject() {
 var aside = document.querySelector('a[href^="mailto:support@zmzmlabs.com"][href*="COA"]');
 if (!aside) return;
 var container = aside.closest('aside') || aside.parentElement;
 if (!container || container.dataset.zmzmCoaWrapped === '1') return;
 container.dataset.zmzmCoaWrapped = '1';

 // Hide the original mailto link
 aside.style.display = 'none';

 var formWrap = document.createElement('form');
 formWrap.className = 'zmzm-coa-form';
 formWrap.innerHTML =
 '<input type="text" name="order_number" placeholder="order # (e.g. ZL12345)" autocomplete="off" required>' +
 '<input type="email" name="email" placeholder="email on file" autocomplete="email" required>' +
 '<button type="submit">request coa →</button>' +
 '<div class="zmzm-coa-form__hint">— customer-only · reply within 24h</div>';
 container.appendChild(formWrap);

 formWrap.addEventListener('submit', function (e) {
 e.preventDefault();
 var orderNum = formWrap.querySelector('[name="order_number"]').value.trim();
 var email = formWrap.querySelector('[name="email"]').value.trim();
 if (!orderNum || !email) return;

 // Klaviyo event
 try {
 if (window.klaviyo && typeof window.klaviyo.push === 'function') {
 window.klaviyo.push(['identify', { $email: email, last_coa_request: new Date().toISOString() }]);
 window.klaviyo.push(['track', 'COA Requested', { order_number: orderNum, email: email }]);
 }
 } catch (er) {}

 // Also fire a contact form (Shopify customer note) as a fallback
 var fd = new FormData();
 fd.append('form_type', 'contact');
 fd.append('utf8', '✓');
 fd.append('contact[email]', email);
 fd.append('contact[subject]', 'COA Request — ' + orderNum);
 fd.append('contact[body]', 'Customer requested COA for order ' + orderNum + '.');
 fetch('/contact', { method: 'POST', body: fd }).catch(function () {});

 // Replace form with confirmation
 formWrap.outerHTML = '<p class="zmzm-coa-form__success"><em>received. your batch certificate is on its way to ' + email + ' within 24 hours.</em></p>';
 });
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', inject);
 } else {
 inject();
 }
 setTimeout(inject, 600);
 } catch (e) {}
 })();

 // ============================================================
 // FIX 5b — Member-gated "By Prayer" navigation
 // If logged out, intercepts the click and shows a soft member-modal.
 // ============================================================
 (function memberGateByPrayer() {
 try {
 // Detect logged-in via the customer.id Liquid that Astra exposes globally
 var isLoggedIn = !!(window.Shopify && window.Shopify.customer && window.Shopify.customer.id);
 if (isLoggedIn) return; // logged-in users access freely

 function tagAndIntercept() {
 var links = document.querySelectorAll('a[aria-label*="Prayer" i], a[href*="barakah-schedule"]');
 links.forEach(function (a) {
 var label = (a.textContent || '').trim().toLowerCase();
 if (label.indexOf('by prayer') === -1 && label.indexOf('the schedule') === -1 && label.indexOf('barakah schedule') === -1) return;
 if (a.dataset.zmzmGated === '1') return;
 a.dataset.zmzmGated = '1';
 a.classList.add('zmzm-member-locked');
 a.addEventListener('click', function (e) {
 // Only gate menu-item versions, not the bottom-nav or context CTA
 if (a.closest('.zmzm-bottom-nav') || a.closest('.zmzm-context-cta')) return;
 e.preventDefault();
 showModal(a.href);
 });
 });
 }

 function showModal(intendedUrl) {
 var existing = document.querySelector('.zmzm-member-modal');
 if (existing) existing.remove();
 var modal = document.createElement('div');
 modal.className = 'zmzm-member-modal';
 modal.innerHTML =
 '<div class="zmzm-member-modal__sheet">' +
 '<div class="zmzm-member-modal__handle"></div>' +
 '<div class="zmzm-member-modal__tag">— members only · always free</div>' +
 '<h3 class="zmzm-member-modal__title">your routine, on the rhythm.</h3>' +
 '<p class="zmzm-member-modal__sub">members get live prayer-time alignment, the schedule app, and member-only drops. one-tap signup, free forever.</p>' +
 '<a class="zmzm-member-modal__cta" href="/account/register?return_to=' + encodeURIComponent(intendedUrl || '/collections/the-barakah-schedule') + '">become a member →</a>' +
 '<button class="zmzm-member-modal__skip" type="button">browse without joining</button>' +
 '</div>';
 document.body.appendChild(modal);
 requestAnimationFrame(function () { modal.classList.add('is-open'); });

 modal.addEventListener('click', function (e) {
 if (e.target === modal) close();
 });
 modal.querySelector('.zmzm-member-modal__skip').addEventListener('click', function () {
 close();
 window.location.href = intendedUrl || '/collections/the-barakah-schedule';
 });
 function close() {
 modal.classList.remove('is-open');
 setTimeout(function () { modal.remove(); }, 360);
 }
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', tagAndIntercept);
 } else {
 tagAndIntercept();
 }
 setTimeout(tagAndIntercept, 800);
 } catch (e) {}
 })();

 // Auto-tag every Shopify section (except header / footer / quiz / already-Astra-animated)
 // with our fade-on-scroll class so the whole page reads as paced.
 (function applyGlobalScrollReveal() {
 try {
 if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
 function tag() {
 document.querySelectorAll('.shopify-section').forEach(function (el) {
 if (el.classList.contains('shopify-section-group-main-header-group')) return;
 if (el.classList.contains('shopify-section-footer')) return;
 if (el.classList.contains('shopify-section-group-popup-group')) return;
 if (el.classList.contains('shopify-section-group-main-aside-group')) return;
 // Skip if Astra already animates it (avoid double-anim)
 if (el.querySelector('.scroll-trigger')) return;
 if (el.classList.contains('zmzm-fade-on-scroll')) return;
 el.classList.add('zmzm-fade-on-scroll');
 });
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', tag);
 } else {
 tag();
 }
 } catch (e) {}
 })();

 // Flag body when user arrives from the quiz (URL params or sessionStorage)
 (function flagFromQuiz() {
 try {
 var params = new URLSearchParams(window.location.search);
 var fromQuiz = params.has('subscription') || params.has('segment') || params.has('goal');
 var quizDone = sessionStorage.getItem('zmzm_quiz_complete') === '1';
 var onCollection = window.location.pathname.indexOf('/collections') === 0;
 if (onCollection && (fromQuiz || quizDone)) {
 document.body.setAttribute('data-zmzm-from-quiz', '1');
 }
 } catch (e) {}
 })();

 // Gap #8 — Pin a promoted "your bundle" card at the top of the products grid
 // when a user lands on the Barakah Schedule from the quiz with a known rhythm.
 (function pinBundleCard() {
 try {
 if (window.location.pathname.indexOf('/collections/the-barakah-schedule') !== 0) return;
 var params = new URLSearchParams(window.location.search);
 var goal = params.get('goal');
 var segment = params.get('segment');
 // Need rhythm to know which bundle. Pull from sessionStorage written by quiz.
 var rhythm = sessionStorage.getItem('zmzm_quiz_rhythm');
 if (!rhythm) {
 // fallback — read from saved progress
 var raw = localStorage.getItem('zmzm_quiz_progress');
 if (raw) {
 try { rhythm = (JSON.parse(raw).answers || {}).prayer; } catch (e) {}
 }
 }
 if (!rhythm || !goal) return;

 // Wudu bundle for beauty-goal users, stack bundle for everyone else
 var STACK_BUNDLE = {
 fajr: { handle:'fajr-stack-bundle', title:'fajr stack bundle', why:'the full pre-dawn-to-morning routine, packaged.' },
 dhuhr: { handle:'dhuhr-stack-bundle', title:'dhuhr stack bundle', why:'midday balance — one tap, one shipment.' },
 asr: { handle:'asr-stack-bundle', title:'asr stack bundle', why:'the afternoon-window stack, end to end.' },
 maghrib: { handle:'maghrib-stack-bundle', title:'maghrib stack bundle', why:'the sundown-to-evening routine, packaged.' },
 isha: { handle:'isha-stack-bundle', title:'isha stack bundle', why:'the night-window routine, packaged.' }
 };
 var WUDU_BUNDLE = {
 fajr: { handle:'fajr-wudu-bundle', title:'fajr wudu bundle', why:'the morning skincare ritual — wudu-safe, end to end.' },
 dhuhr: { handle:'dhuhr-wudu-bundle', title:'dhuhr wudu bundle', why:'midday refresh — wudu-safe, lightweight.' },
 asr: { handle:'asr-wudu-bundle', title:'asr wudu bundle', why:'afternoon skincare reset — wudu-safe.' },
 maghrib: { handle:'maghrib-wudu-bundle', title:'maghrib wudu bundle', why:'the sundown ritual — purifying mud, restoring layers.' },
 isha: { handle:'isha-wudu-bundle', title:'isha wudu bundle', why:'the overnight repair stack — wudu-safe.' }
 };
 var src = (goal === 'beauty') ? WUDU_BUNDLE : STACK_BUNDLE;
 var bundle = src[rhythm];
 if (!bundle) return;

 function inject() {
 var grid = document.querySelector('.shop__products-grid-wrap, [class*="product-list__grid"], #ShopProducts [class*="grid"]');
 if (!grid || grid.querySelector('.zmzm-promoted-bundle')) return;
 var card = document.createElement('a');
 card.className = 'zmzm-promoted-bundle';
 card.href = '/products/' + bundle.handle + '?subscription=' + (params.get('subscription') || 'monthly');
 card.innerHTML =
 '<div class="zmzm-promoted-bundle__tag">your barakah brief · pinned</div>' +
 '<div class="zmzm-promoted-bundle__title">' + bundle.title + '</div>' +
 '<div class="zmzm-promoted-bundle__why">' + bundle.why + '</div>' +
 '<div class="zmzm-promoted-bundle__cta">view bundle <svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></div>';
 grid.insertBefore(card, grid.firstChild);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', inject);
 } else {
 inject();
 }
 // Also retry once after Astra finishes its progressive render
 setTimeout(inject, 600);
 } catch (e) {}
 })();

 // ============================================================
 // Gap #11/#12 — pre-select subscription tier on PDPs from quiz
 // The quiz CTA appends ?subscription=monthly|every-2|every-3 to product/collection URLs.
 // On PDP load, find Shopify's subscription radio and pre-select it.
 // Show a small mono "from your barakah brief" tag near the option.
 // ============================================================
 (function applySubscriptionFromUrl() {
 try {
 if (window.location.pathname.indexOf('/products/') !== 0) return;
 var params = new URLSearchParams(window.location.search);
 var sub = params.get('subscription') || sessionStorage.getItem('zmzm_quiz_tier');
 if (!sub || sub === 'none') return;

 var CADENCE_TO_KEYWORDS = {
 'monthly': ['monthly', '1 month', 'every month', '30 day'],
 'every-2': ['2 month', '60 day', 'every 2', 'bi-monthly'],
 'every-3': ['3 month', '90 day', 'every 3', 'quarterly']
 };
 var keywords = CADENCE_TO_KEYWORDS[sub] || [];

 function findAndSelect() {
 // Astra theme uses data-radio-type='selling_plan' (no name attr).
 // Shopify standard subscription apps use name="selling_plan" or
 // <selling-plan-allocation> custom elements. Match all three.
 var radios = document.querySelectorAll(
 'input[type="radio"][data-radio-type="selling_plan"], ' +
 'input[type="radio"][name*="selling_plan"], ' +
 'input[type="radio"][name*="purchase_option"], ' +
 'input[type="radio"][value*="subscription" i]'
 );
 if (!radios.length) return false;

 var matched = null;
 radios.forEach(function (r) {
 var label = (r.closest('label') || r.parentElement || {}).textContent || '';
 var lower = label.toLowerCase();
 if (keywords.some(function (k) { return lower.indexOf(k) !== -1; })) {
 if (!matched) matched = r;
 }
 });

 // Fall back: just find the first subscription radio (skip one-time)
 if (!matched) {
 radios.forEach(function (r) {
 // Astra's one-time radio uses data-radio-type='one_time_purchase'
 if (r.dataset && r.dataset.radioType === 'one_time_purchase') return;
 var label = (r.closest('label') || r.parentElement || {}).textContent || '';
 if (label.toLowerCase().indexOf('one-time') === -1 && !matched) matched = r;
 });
 }

 if (matched && !matched.checked) {
 matched.checked = true;
 matched.dispatchEvent(new Event('change', { bubbles: true }));
 matched.dispatchEvent(new Event('input', { bubbles: true }));

 // Add a quiet "from your brief" tag next to the option
 var label = matched.closest('label');
 if (label && !label.querySelector('.zmzm-from-brief-tag')) {
 var tag = document.createElement('span');
 tag.className = 'zmzm-from-brief-tag';
 tag.textContent = 'from your brief';
 label.appendChild(tag);
 }
 return true;
 }
 return false;
 }

 // Initial attempt + retry across the progressive render lifecycle
 var attempts = 0;
 var iv = setInterval(function () {
 if (findAndSelect() || ++attempts > 12) clearInterval(iv);
 }, 250);
 } catch (e) {}
 })();

 // ============================================================
 // Gap #14 — Badge PDP if the product was in the user's quiz stack
 // ============================================================
 (function badgeStackProduct() {
 try {
 if (window.location.pathname.indexOf('/products/') !== 0) return;
 var match = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
 if (!match) return;
 var handle = match[1];
 var stackRaw = sessionStorage.getItem('zmzm_quiz_stack');
 if (!stackRaw) return;
 var stack = JSON.parse(stackRaw);
 if (!stack.indexOf || stack.indexOf(handle) === -1) return;

 function injectBadge() {
 var titleEl = document.querySelector('.product-general-info-block h1, .product-general-info-block__vendor');
 if (!titleEl || document.querySelector('.zmzm-stack-badge')) return;
 var rhythm = sessionStorage.getItem('zmzm_quiz_rhythm') || '';
 var badge = document.createElement('div');
 badge.className = 'zmzm-stack-badge';
 badge.innerHTML =
 '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"/></svg>' +
 'in your barakah brief' + (rhythm ? ' · ' + rhythm + ' window' : '');
 titleEl.parentElement.insertBefore(badge, titleEl);
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', injectBadge);
 } else {
 injectBadge();
 }
 setTimeout(injectBadge, 600);
 } catch (e) {}
 })();

 // ============================================================
 // Gap #13 — 24h "where you left off" floating reminder
 // ============================================================
 (function postQuizReminder() {
 try {
 if (!isMobile()) return;
 // Don't show on the quiz itself, on cart, or in checkout
 var path = window.location.pathname;
 if (path.indexOf('/pages/barakah-quiz') === 0 || path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;
 // Don't show if user is on the destination they were headed to
 var params = new URLSearchParams(window.location.search);
 if (params.has('subscription') || params.has('segment') || params.has('goal')) return;

 var done = sessionStorage.getItem('zmzm_quiz_complete') === '1';
 if (!done) return;
 var dismissed = sessionStorage.getItem('zmzm_quiz_reminder_dismissed') === '1';
 if (dismissed) return;
 var completedAt = parseInt(sessionStorage.getItem('zmzm_quiz_completed_at') || '0', 10);
 if (!completedAt) return;
 // Show only within 24h of completion
 if (Date.now() - completedAt > 24 * 60 * 60 * 1000) return;

 var goal = sessionStorage.getItem('zmzm_quiz_goal') || '';
 var rhythm = sessionStorage.getItem('zmzm_quiz_rhythm') || '';

 function inject() {
 if (document.querySelector('.zmzm-resume-card')) return;
 var card = document.createElement('a');
 card.className = 'zmzm-resume-card';
 card.href = '/collections/the-barakah-schedule?subscription=' +
 (sessionStorage.getItem('zmzm_quiz_tier') || 'monthly') +
 '&goal=' + goal + '&segment=' + (sessionStorage.getItem('zmzm_quiz_segment') || '');
 card.innerHTML =
 '<button class="zmzm-resume-card__dismiss" aria-label="Dismiss" type="button">×</button>' +
 '<div class="zmzm-resume-card__tag">your routine, where you left off</div>' +
 '<div class="zmzm-resume-card__title">your ' + (goal || 'routine') + ' stack' + (rhythm ? ' · ' + rhythm + ' window' : '') + '</div>' +
 '<div class="zmzm-resume-card__cta">continue →</div>';
 document.body.appendChild(card);
 setTimeout(function () { card.classList.add('is-visible'); }, 1800);

 card.querySelector('.zmzm-resume-card__dismiss').addEventListener('click', function (e) {
 e.preventDefault();
 e.stopPropagation();
 try { sessionStorage.setItem('zmzm_quiz_reminder_dismissed', '1'); } catch (er) {}
 card.classList.remove('is-visible');
 setTimeout(function () { card.remove(); }, 400);
 });
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', inject);
 } else {
 inject();
 }
 } catch (e) {}
 })();

 // ============================================================
 // OPTION A — Bottom tab nav + sticky context CTA
 // ============================================================
 function buildBottomNav() {
 if (!isMobile()) return;
 if (document.querySelector('.zmzm-bottom-nav')) return;

 var path = window.location.pathname;
 var cartCount = (window.Shopify && window.Shopify.cartCount) ||
 parseInt(document.querySelector('[class*="cart-count"]')?.textContent || '0', 10) || 0;

 var nav = document.createElement('nav');
 nav.className = 'zmzm-bottom-nav';
 nav.setAttribute('aria-label', 'Primary navigation');

 var items = [
 { tab: 'home', href: '/', label: 'home',
 match: function (p) { return p === '/'; },
 icon: '<path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1z"/>' },
 { tab: 'shop', href: '/collections/all', label: 'shop',
 match: function (p) { return p.indexOf('/collections') === 0 || p.indexOf('/products') === 0; },
 icon: '<path d="M5 8h14l-1.5 11a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 8z"/><path d="M9 8a3 3 0 0 1 6 0"/>' },
 { tab: 'quiz', href: '/pages/barakah-quiz', label: 'quiz',
 match: function (p) { return p.indexOf('quiz') !== -1; },
 icon: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 4.2 1.8c-.7.6-1.7 1-1.7 2.2"/><circle cx="12" cy="17" r="0.6" fill="currentColor"/>' },
 { tab: 'cart', href: '#cart', label: 'cart',
 match: function (p) { return p.indexOf('/cart') === 0; },
 icon: '<path d="M3 5h2l2.5 11.5a2 2 0 0 0 2 1.5h7.5a2 2 0 0 0 2-1.5L21 8H6"/><circle cx="10" cy="20" r="1"/><circle cx="17" cy="20" r="1"/>' },
 { tab: 'account', href: '/account', label: 'me',
 match: function (p) { return p.indexOf('/account') === 0; },
 icon: '<circle cx="12" cy="9" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>' },
 ];

 items.forEach(function (it) {
 var a = document.createElement('a');
 a.className = 'zmzm-bn__item' + (it.match(path) ? ' is-active' : '');
 a.href = it.href;
 a.setAttribute('data-tab', it.tab);
 a.innerHTML =
 '<svg class="zmzm-bn__icon" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + it.icon + '</svg>' +
 '<span>' + it.label + '</span>' +
 (it.tab === 'cart' ? '<span class="zmzm-bn__badge"' + (cartCount === 0 ? ' hidden' : '') + '>' + cartCount + '</span>' : '');

 if (it.tab === 'cart') {
 a.addEventListener('click', function (e) {
 // Try to open the existing Astra cart drawer
 var drawerTrigger = document.querySelector('[data-cart-drawer-toggle], [aria-controls*="cart-drawer"], a[href="/cart"][class*="header"], button[class*="cart"][class*="toggle"]');
 if (drawerTrigger && drawerTrigger !== a) {
 e.preventDefault();
 drawerTrigger.click();
 }
 // else fallback to /cart page
 });
 }

 nav.appendChild(a);
 });

 document.body.appendChild(nav);

 // Hide nav on scroll down, reveal on scroll up
 var lastY = window.scrollY;
 var ticking = false;
 window.addEventListener('scroll', function () {
 if (ticking) return;
 ticking = true;
 requestAnimationFrame(function () {
 var y = window.scrollY;
 if (y > lastY + 8 && y > 120) {
 nav.classList.add('zmzm-bottom-nav--hidden');
 } else if (y < lastY - 4) {
 nav.classList.remove('zmzm-bottom-nav--hidden');
 }
 lastY = y;
 ticking = false;
 });
 }, { passive: true });
 }

 function buildContextCta() {
 if (!isMobile()) return;
 if (document.querySelector('.zmzm-context-cta')) return;

 var path = window.location.pathname;
 var cta = null;

 // Don't compete with PDP sticky ATC
 if (path.indexOf('/products/') === 0) return;

 // Suppress on quiz-completion landings (user just took the quiz)
 var params = new URLSearchParams(window.location.search);
 var fromQuiz = params.has('subscription') || params.has('segment') || params.has('goal');
 var quizComplete = false;
 try { quizComplete = sessionStorage.getItem('zmzm_quiz_complete') === '1'; } catch (e) {}

 if (path === '/') {
 // If they already completed the quiz this session, change CTA to a softer "your routine" entry
 if (quizComplete) {
 cta = { label: 'continue', title: 'your routine awaits', href: '/collections/the-barakah-schedule' };
 } else {
 cta = { label: 'start here', title: 'build your routine', href: '/pages/barakah-quiz' };
 }
 } else if (path.indexOf('/collections') === 0) {
 // Hide quiz CTA on the post-quiz landing collection
 if (fromQuiz || quizComplete) return;
 cta = { label: 'not sure where to start', title: 'take the 90-second quiz', href: '/pages/barakah-quiz' };
 } else if (path.indexOf('/pages/') === 0 && path.indexOf('quiz') === -1) {
 cta = { label: 'browse', title: 'shop the collection', href: '/collections/all' };
 } else if (path.indexOf('/blogs') === 0) {
 cta = { label: 'browse', title: 'shop the collection', href: '/collections/all' };
 }

 if (!cta) return;

 var a = document.createElement('a');
 a.className = 'zmzm-context-cta';
 a.href = cta.href;
 a.innerHTML =
 '<div><span class="zmzm-context-cta__label">' + cta.label + '</span>' +
 '<span class="zmzm-context-cta__title">' + cta.title + '</span></div>' +
 '<svg class="zmzm-context-cta__arrow" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
 document.body.appendChild(a);

 // Delay reveal for ceremony
 setTimeout(function () { a.classList.add('is-visible'); }, 1200);

 // Hide on cart drawer open
 document.addEventListener('click', function (e) {
 if (e.target.closest('.zmzm-bn__item[data-tab="cart"], [class*="cart-drawer"]')) {
 a.classList.remove('is-visible');
 }
 });
 }

 // ============================================================
 // OPTION B — Quiz-as-front-door onboarding
 // ============================================================
 function buildOnboarding() {
 if (!isMobile()) return;
 if (window.location.pathname !== '/') return;
 try {
 if (sessionStorage.getItem('zmzm_onboarded') === '1') return;
 if (localStorage.getItem('zmzm_onboarded') === '1') return;
 } catch (e) {}

 var ov = document.createElement('div');
 ov.className = 'zmzm-onboard-overlay';
 ov.innerHTML =
 '<div class="zmzm-onboard-rule"></div>' +
 '<h1 class="zmzm-onboard-headline">a sanctuary for your body, built for the rhythm of your day.</h1>' +
 '<p class="zmzm-onboard-sub">ninety seconds. five questions. a routine made for you, not for the algorithm.</p>' +
 '<div class="zmzm-onboard-actions">' +
 '<a class="zmzm-onboard-btn" href="/pages/barakah-quiz" data-action="quiz">' +
 '<span>build my routine</span>' +
 '<svg class="zmzm-onboard-arrow" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
 '</a>' +
 '<button class="zmzm-onboard-btn zmzm-onboard-skip" type="button" data-action="skip">i’ll explore first</button>' +
 '</div>';
 document.body.appendChild(ov);

 // Lock scroll while overlay is up
 var prevOverflow = document.body.style.overflow;
 document.body.style.overflow = 'hidden';

 // Reveal after ~600ms (Aman pacing)
 setTimeout(function () { ov.classList.add('is-visible'); }, 600);

 function dismiss(viaQuiz) {
 try {
 sessionStorage.setItem('zmzm_onboarded', '1');
 localStorage.setItem('zmzm_onboarded', '1');
 } catch (e) {}
 ov.classList.remove('is-visible');
 setTimeout(function () {
 document.body.style.overflow = prevOverflow;
 ov.remove();
 }, 720);
 }

 ov.querySelector('[data-action="skip"]').addEventListener('click', function () {
 // Klaviyo: log that user opted to explore instead of taking the quiz
 try {
 if (window.klaviyo && typeof window.klaviyo.push === 'function') {
 window.klaviyo.push(['track', 'Barakah Onboarding Skipped', {}]);
 } else if (window._learnq && typeof window._learnq.push === 'function') {
 window._learnq.push(['track', 'Barakah Onboarding Skipped', {}]);
 }
 } catch (e) {}
 try { localStorage.setItem('zmzm_explorer_path', '1'); } catch (e) {}
 dismiss(false);
 });
 ov.querySelector('[data-action="quiz"]').addEventListener('click', function () {
 // Mark onboarded; let the link navigate naturally
 try {
 sessionStorage.setItem('zmzm_onboarded', '1');
 localStorage.setItem('zmzm_onboarded', '1');
 } catch (e) {}
 });
 }

 // ============================================================
 // OPTION C — Bottom-sheet PDP restructure
 // ============================================================
 function buildPdpSheets() {
 if (!isMobile()) return;
 if (window.location.pathname.indexOf('/products/') !== 0) return;

 var rte = document.querySelector('.product-content-tab__rte');
 if (!rte || rte.dataset.zmzmRebuilt === '1') return;

 var zpdp = rte.querySelector('.zpdp') || rte;
 // Find h3 sections — each becomes a sheet
 var sections = [];
 var children = Array.prototype.slice.call(zpdp.children);
 var lede = null;
 var priceFrame = null;
 var current = null;

 children.forEach(function (el) {
 if (el.classList && el.classList.contains('zpdp-lede')) {
 lede = el; return;
 }
 if (el.classList && el.classList.contains('zpdp-price-frame')) {
 priceFrame = el; return;
 }
 if (el.tagName === 'H3') {
 current = { title: el.textContent.trim(), nodes: [] };
 sections.push(current);
 } else if (current) {
 current.nodes.push(el);
 } else {
 // pre-h3 paragraph — attach to lede area
 if (!lede && (el.tagName === 'P')) {
 lede = el;
 }
 }
 });

 if (sections.length === 0) return;

 // Build sheet triggers
 var wrap = document.createElement('div');
 wrap.className = 'zmzm-pdp-sheets';

 sections.forEach(function (s, i) {
 var btn = document.createElement('button');
 btn.type = 'button';
 btn.className = 'zmzm-pdp-sheet-btn';
 var num = String(i + 1).padStart(2, '0');
 btn.innerHTML =
 '<div>' +
 '<span class="zmzm-pdp-sheet-btn__num">' + num + ' / ' + String(sections.length).padStart(2, '0') + '</span>' +
 '<span class="zmzm-pdp-sheet-btn__label">' + s.title.toLowerCase() + '</span>' +
 '</div>' +
 '<svg class="zmzm-pdp-sheet-btn__arrow" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
 btn.addEventListener('click', function () { openSheet(s, num + ' / ' + String(sections.length).padStart(2, '0')); });
 wrap.appendChild(btn);
 });

 // Replace dense content with: lede (kept) → sheet triggers → price frame (kept)
 var newRoot = document.createElement('div');
 newRoot.className = 'zpdp zmzm-pdp-mobile';
 if (lede) newRoot.appendChild(lede.cloneNode(true));
 newRoot.appendChild(wrap);
 if (priceFrame) newRoot.appendChild(priceFrame.cloneNode(true));

 rte.innerHTML = '';
 rte.appendChild(newRoot);
 rte.dataset.zmzmRebuilt = '1';
 }

 // Bottom-sheet plumbing
 var sheetOverlay = null;
 function ensureSheetOverlay() {
 if (sheetOverlay) return sheetOverlay;
 sheetOverlay = document.createElement('div');
 sheetOverlay.className = 'zmzm-sheet-overlay';
 sheetOverlay.innerHTML =
 '<div class="zmzm-sheet" role="dialog" aria-modal="true">' +
 '<div class="zmzm-sheet__handle"></div>' +
 '<span class="zmzm-sheet__eyebrow"></span>' +
 '<h2 class="zmzm-sheet__title"></h2>' +
 '<div class="zmzm-sheet__content"></div>' +
 '</div>';
 document.body.appendChild(sheetOverlay);

 sheetOverlay.addEventListener('click', function (e) {
 if (e.target === sheetOverlay) closeSheet();
 });
 document.addEventListener('keydown', function (e) {
 if (e.key === 'Escape') closeSheet();
 });
 return sheetOverlay;
 }

 function openSheet(section, eyebrow) {
 var ov = ensureSheetOverlay();
 ov.querySelector('.zmzm-sheet__eyebrow').textContent = eyebrow || '';
 ov.querySelector('.zmzm-sheet__title').textContent = section.title.toLowerCase();
 var content = ov.querySelector('.zmzm-sheet__content');
 content.innerHTML = '';
 section.nodes.forEach(function (n) { content.appendChild(n.cloneNode(true)); });
 ov.classList.add('is-open');
 document.body.style.overflow = 'hidden';
 }
 function closeSheet() {
 if (!sheetOverlay) return;
 sheetOverlay.classList.remove('is-open');
 document.body.style.overflow = '';
 }

 // ── Boot ─────────────────────────────────────
 function boot() {
 buildOnboarding(); // first — covers screen
 buildBottomNav();
 buildContextCta();
 buildPdpSheets();
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', boot);
 } else {
 boot();
 }

 /* === ZMZM polish (May 6, 2026): trust strip injection, free shipping celebration, sticky ATC, discount auto-expand === */

 // 1. Cart trust strip injection
 function zmzmInjectCartTrust() {
 var TRUST_HTML = '<div class="zmzm-cart-trust" role="region" aria-label="Trust signals">' +
 '<span class="zmzm-cart-trust__pill">Free Shipping over $50</span>' +
 '<span class="zmzm-cart-trust__pill">Ships in 1–2 days</span>' +
 '<span class="zmzm-cart-trust__pill">30-day returns</span>' +
 '<span class="zmzm-cart-trust__pill">Halal Standards</span>' +
 '</div>';
 var btns = document.querySelectorAll('button[name="checkout"], .cart-drawer-subtotal__btn, [class*="cart-drawer-subtotal__cta"]');
 btns.forEach(function (btn) {
 var host = btn.closest('.cart-drawer-subtotal, [class*="cart-totals"], form, fieldset') || btn.parentElement;
 if (!host || host.querySelector('.zmzm-cart-trust')) return;
 var anchor = btn.closest('button[name="checkout"]') || btn;
 var wrap = document.createElement('div');
 wrap.innerHTML = TRUST_HTML;
 try { host.insertBefore(wrap.firstElementChild, anchor); } catch (e) { host.appendChild(wrap.firstElementChild); }
 });
 }

 // 2. Free shipping unlocked detection
 function zmzmCheckFreeShipping() {
 document.querySelectorAll('free-shipping-bar').forEach(function (bar) {
 var threshold = parseFloat(bar.getAttribute('data-threshold') || '0');
 var total = parseFloat(bar.getAttribute('data-cart-total') || '0');
 if (threshold > 0 && total >= threshold) {
 bar.classList.add('zmzm-fs-unlocked');
 } else {
 bar.classList.remove('zmzm-fs-unlocked');
 }
 });
 }

 // 3. Sticky mobile add-to-cart
 function zmzmSetupStickyATC() {
 if (window.innerWidth > 768) return;
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-sticky-atc')) return;
 var realBtn = document.querySelector('product-form button[type="submit"], button[name="add"]:not([data-zmzm-sticky])');
 if (!realBtn) return;
 var priceEl = document.querySelector('[class*="product-price"] [class*="price-item--regular"], [class*="product-price"] [class*="price-item"], product-price [class*="price-item"]');
 var price = priceEl ? priceEl.textContent.trim().split(/\s+/).slice(0, 1).join('') : '';
 var sticky = document.createElement('div');
 sticky.className = 'zmzm-sticky-atc';
 sticky.innerHTML = '<div class="zmzm-sticky-atc__inner">' +
 (price ? '<span class="zmzm-sticky-atc__price">' + price + '</span>' : '') +
 '<button type="button" class="zmzm-sticky-atc__btn" data-zmzm-sticky>Add to Cart</button>' +
 '</div>';
 document.body.appendChild(sticky);
 var stickyBtn = sticky.querySelector('button');
 stickyBtn.addEventListener('click', function () { realBtn.click(); });
 // Mirror disabled state (out of stock)
 function syncDisabled() {
 stickyBtn.disabled = realBtn.disabled;
 stickyBtn.textContent = realBtn.disabled ? 'Sold Out' : 'Add to Cart';
 }
 syncDisabled();
 new MutationObserver(syncDisabled).observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
 // Show only after scrolling past real ATC
 if (typeof IntersectionObserver === 'function') {
 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (entry) {
 if (entry.isIntersecting) sticky.classList.remove('zmzm-sticky-atc--visible');
 else sticky.classList.add('zmzm-sticky-atc--visible');
 });
 }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });
 io.observe(realBtn);
 } else {
 sticky.classList.add('zmzm-sticky-atc--visible');
 }
 }

 // 4. Auto-expand discount field for email/sms/klaviyo traffic
 function zmzmAutoExpandDiscount() {
 var params = new URLSearchParams(location.search);
 var src = (params.get('utm_source') || '').toLowerCase();
 if (!src || !['email', 'sms', 'klaviyo', 'mailchimp'].includes(src)) return;
 document.body.setAttribute('data-zmzm-discount-auto', 'true');
 document.querySelectorAll('[class*="discount"][class*="toggle"], [data-discount-toggle], button[aria-controls*="iscount"]').forEach(function (toggle) {
 if (toggle.getAttribute('aria-expanded') === 'false' || toggle.classList.contains('is-closed')) {
 try { toggle.click(); } catch (e) {}
 }
 });
 }

 // Run all
 function zmzmRunPolishSuite() {
 zmzmInjectCartTrust();
 zmzmCheckFreeShipping();
 zmzmSetupStickyATC();
 zmzmAutoExpandDiscount();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunPolishSuite);
 } else {
 zmzmRunPolishSuite();
 }
 // Re-run on cart updates (cart drawer re-renders content)
 ['cart:updated', 'cart:refresh', 'on:cart:after-update', 'cart-drawer:opened', 'cart-drawer:open'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunPolishSuite, 80); });
 });
 // Re-check free shipping when DOM changes (cart line item add/remove updates the bar)
 if (typeof MutationObserver === 'function') {
 var fsObs = new MutationObserver(function () { zmzmCheckFreeShipping(); zmzmInjectCartTrust(); });
 document.querySelectorAll('cart-drawer, [class*="cart-drawer"]').forEach(function (el) {
 fsObs.observe(el, { attributes: true, attributeFilter: ['data-cart-total'], subtree: true, childList: true });
 });
 }


 /* === ZMZM polish bundle 2 (May 6, 2026): swipe-to-dismiss, ATC pulse, accessibility === */

 // 1. Cart drawer swipe-to-dismiss (mobile)
 function zmzmAttachSwipeDismiss() {
 if (window.innerWidth > 768) return;
 var drawer = document.querySelector('cart-drawer');
 if (!drawer || drawer.dataset.zmzmSwipeAttached) return;
 drawer.dataset.zmzmSwipeAttached = 'true';
 var startY = null, currentY = null, panel;
 drawer.addEventListener('touchstart', function (e) {
 panel = drawer.querySelector('[class*="cart-drawer__panel"], aside') || drawer;
 // Only start swipe gesture from near the top of the drawer
 var rect = panel.getBoundingClientRect();
 if (e.touches[0].clientY > rect.top + 60) return;
 startY = e.touches[0].clientY;
 }, { passive: true });
 drawer.addEventListener('touchmove', function (e) {
 if (startY === null) return;
 currentY = e.touches[0].clientY;
 var dy = Math.max(0, currentY - startY);
 if (dy > 0 && panel) {
 panel.style.transform = 'translateY(' + dy + 'px)';
 panel.style.transition = 'none';
 }
 }, { passive: true });
 drawer.addEventListener('touchend', function () {
 if (startY === null) return;
 var dy = (currentY || startY) - startY;
 if (panel) {
 panel.style.transition = 'transform 240ms cubic-bezier(0.16, 1, 0.3, 1)';
 if (dy > 120) {
 // Close drawer
 var closeBtn = drawer.querySelector('[class*="close-button"], [aria-label*="lose" i]');
 if (closeBtn) closeBtn.click();
 panel.style.transform = '';
 } else {
 panel.style.transform = '';
 }
 }
 startY = null; currentY = null;
 });
 }

 // 2. ATC button — pulse on success + live region announcement
 function zmzmAnnounceATC() {
 var live = document.getElementById('zmzm-atc-live');
 if (!live) {
 live = document.createElement('div');
 live.id = 'zmzm-atc-live';
 live.setAttribute('role', 'status');
 live.setAttribute('aria-live', 'polite');
 live.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
 document.body.appendChild(live);
 }
 document.addEventListener('click', function (e) {
 var btn = e.target.closest('button[name="add"], product-form button[type="submit"], .zmzm-sticky-atc__btn');
 if (!btn || btn.disabled) return;
 // Pulse
 btn.classList.add('zmzm-atc-pulse');
 setTimeout(function () { btn.classList.remove('zmzm-atc-pulse'); }, 320);
 // Announce shortly after (gives time for cart to update)
 setTimeout(function () {
 var pTitle = document.querySelector('.product__title, [class*="product-title"], h1');
 var name = pTitle ? pTitle.textContent.trim().slice(0, 60) : 'Item';
 live.textContent = name + ' added to cart.';
 }, 600);
 });
 }

 // 3. View Full Cart link — ensure it's visible on mobile cart drawer
 function zmzmEnsureViewCartLink() {
 if (window.innerWidth > 768) return;
 var drawer = document.querySelector('cart-drawer');
 if (!drawer) return;
 var existing = drawer.querySelector('.cart-drawer-subtotal__cart-link, [href$="/cart"]');
 if (existing) return; // already there
 var subtotal = drawer.querySelector('.cart-drawer-subtotal');
 if (!subtotal) return;
 var link = document.createElement('a');
 link.href = '/cart';
 link.className = 'cart-drawer-subtotal__cart-link';
 link.textContent = 'view full cart';
 subtotal.appendChild(link);
 }

 // 4. Sticky ATC — re-init on variant change (price might update)
 function zmzmRefreshStickyATC() {
 var sticky = document.querySelector('.zmzm-sticky-atc');
 if (!sticky) return;
 var priceEl = document.querySelector('[class*="product-price"] [class*="price-item--regular"], [class*="product-price"] [class*="price-item"]');
 var priceSpan = sticky.querySelector('.zmzm-sticky-atc__price');
 if (priceEl && priceSpan) {
 priceSpan.textContent = priceEl.textContent.trim().split(/\s+/).slice(0, 1).join('');
 }
 }

 function zmzmRunBundle2() {
 zmzmAttachSwipeDismiss();
 zmzmAnnounceATC();
 zmzmEnsureViewCartLink();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunBundle2);
 } else {
 zmzmRunBundle2();
 }
 ['cart:updated', 'cart-drawer:opened', 'variant:changed', 'on:variant:change'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(function () { zmzmRunBundle2(); zmzmRefreshStickyATC(); }, 80); });
 });


 /* === ZMZM polish bundle 3 (May 6, 2026): empty cart, lazy-load, scroll perf === */

 // 1. Apply lazy-loaded class as images come into view (for fade-in)
 function zmzmInitLazyFadeIn() {
 document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
 if (img.complete && img.naturalWidth > 0) {
 img.classList.add('lazy-loaded');
 } else {
 img.addEventListener('load', function () { img.classList.add('lazy-loaded'); }, { once: true });
 img.addEventListener('error', function () { img.classList.add('lazy-loaded'); }, { once: true });
 }
 });
 }

 // 2. Empty cart drawer enrichment — inject secondary CTA when cart is empty
 function zmzmEnrichEmptyCart() {
 var emptyContainer = document.querySelector('.sidebar-cart__warning, [class*="cart-drawer"][class*="empty"], [class*="empty-cart"]');
 if (!emptyContainer) return;
 if (emptyContainer.querySelector('.zmzm-empty-cart-cta')) return;
 var existingBtn = emptyContainer.querySelector('a, button');
 var cta = document.createElement('div');
 cta.className = 'zmzm-empty-cart-cta';
 cta.innerHTML =
 '<a class="zmzm-empty-cart-cta__primary" href="/collections/all">Shop All Products</a>' +
 '<a class="zmzm-empty-cart-cta__secondary" href="/pages/barakah-quiz">Not sure? Take the 60-second quiz</a>';
 if (existingBtn && existingBtn.classList.contains('sidebar-cart__warning-btn')) {
 // Hide the default button to avoid duplication
 existingBtn.style.display = 'none';
 }
 emptyContainer.appendChild(cta);
 }

 // 3. Mark cart items as loading during cart updates (skeleton shimmer trigger)
 function zmzmCartLoadingState() {
 document.addEventListener('cart:request-started', function () {
 document.querySelectorAll('cart-item').forEach(function (item) {
 item.classList.add('cart-item--loading');
 });
 });
 document.addEventListener('cart:request-ended', function () {
 document.querySelectorAll('cart-item').forEach(function (item) {
 item.classList.remove('cart-item--loading');
 });
 });
 }

 // 4. Promote Judgeme review badge near PDP title if it loads after we mounted
 function zmzmPromoteReviewBadge() {
 if (!document.body.classList.contains('template-product')) return;
 // Wait for Judgeme to inject the badge
 var attempts = 0;
 var interval = setInterval(function () {
 attempts++;
 var badge = document.querySelector('.jdgm-prev-badge');
 var title = document.querySelector('h1.product__title, [class*="product-title"]');
 if (badge && title && !title.parentElement.querySelector('.jdgm-prev-badge')) {
 // Move badge to right after title
 title.parentElement.insertBefore(badge, title.nextSibling);
 clearInterval(interval);
 }
 if (attempts > 20) clearInterval(interval); // give up after ~6s
 }, 300);
 }

 // 5. Smooth scroll for back-to-top
 function zmzmEnhanceBackToTop() {
 var btns = document.querySelectorAll('back-to-top-button button, [class*="back-to-top"]');
 btns.forEach(function (btn) {
 if (btn.dataset.zmzmEnhanced) return;
 btn.dataset.zmzmEnhanced = 'true';
 btn.addEventListener('click', function (e) {
 if (window.scrollY < 50) return;
 e.preventDefault();
 window.scrollTo({ top: 0, behavior: 'smooth' });
 });
 });
 }

 function zmzmRunBundle3() {
 zmzmInitLazyFadeIn();
 zmzmEnrichEmptyCart();
 zmzmPromoteReviewBadge();
 zmzmEnhanceBackToTop();
 }
 zmzmCartLoadingState(); // attach listeners once
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunBundle3);
 } else {
 zmzmRunBundle3();
 }
 ['cart:updated', 'cart-drawer:opened', 'shopify:section:load'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunBundle3, 80); });
 });


 /* === ZMZM polish bundle 4 (May 6, 2026): 404 helper, ATC toast fallback === */

 // 1. 404 page — log the missed URL for future redirect setup, suggest a search
 function zmzm404Helper() {
 if (!document.body.classList.contains('template-404')) return;
 var path = window.location.pathname;
 // Try to suggest a product based on path slug
 var slug = path.replace(/^\/+|\/+$/g, '').split('/').pop() || '';
 var keywords = slug.replace(/-/g, ' ').replace(/[^a-z0-9 ]/gi, '').trim();
 if (keywords.length > 2) {
 var main = document.querySelector('main, body.template-404 [class*="404"]') || document.body;
 if (!main.querySelector('.zmzm-404-search')) {
 var search = document.createElement('p');
 search.className = 'zmzm-404-search';
 search.innerHTML = 'Looking for something specific? <a href="/search?q=' + encodeURIComponent(keywords) + '">Search "' + keywords + '"</a>';
 search.style.marginTop = '16px';
 main.appendChild(search);
 }
 }
 }

 // 2. ATC fallback toast — if Astra's cart notification doesn't appear within 1.5s of clicking ATC, show our own
 function zmzmATCToast() {
 document.addEventListener('click', function (e) {
 var btn = e.target.closest('button[name="add"], product-form button[type="submit"], .zmzm-sticky-atc__btn');
 if (!btn || btn.disabled) return;
 var pTitle = document.querySelector('.product__title, [class*="product-title"], h1');
 var name = pTitle ? pTitle.textContent.trim().slice(0, 50) : 'Item';
 // Wait to see if Astra's notification appears
 setTimeout(function () {
 var existing = document.querySelector('cart-notification-popup, [class*="cart-notification"]:not([hidden])');
 if (existing && existing.offsetHeight > 0) return; // Astra handled it
 // Show our own minimal toast
 var existingToast = document.querySelector('.zmzm-toast');
 if (existingToast) existingToast.remove();
 var toast = document.createElement('div');
 toast.className = 'zmzm-toast';
 toast.style.cssText = 'position:fixed;top:80px;left:50%;transform:translateX(-50%);background:var(--zmzm-forest,#0B3D2E);color:var(--zmzm-bone,#f6f5f3);padding:12px 20px;font-family:DM Sans,system-ui,sans-serif;font-size:13px;z-index:10000;box-shadow:0 8px 32px -8px rgba(0,0,0,0.3);max-width:90vw;text-align:center;';
 toast.innerHTML = '✓ Added: ' + name + ' &nbsp;<a href="/cart" style="color:inherit;text-decoration:underline;text-underline-offset:3px;">View cart</a>';
 document.body.appendChild(toast);
 setTimeout(function () {
 toast.style.transition = 'opacity 240ms';
 toast.style.opacity = '0';
 setTimeout(function () { toast.remove(); }, 280);
 }, 3000);
 }, 1500);
 });
 }

 function zmzmRunBundle4() {
 zmzm404Helper();
 }
 zmzmATCToast(); // global listener
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunBundle4);
 } else {
 zmzmRunBundle4();
 }


 /* === ZMZM checkout final polish JS (May 6, 2026): delivery estimate, stock urgency === */

 // Helpers
 function zmzmAddBusinessDays(date, days) {
 var d = new Date(date);
 var added = 0;
 while (added < days) {
 d.setDate(d.getDate() + 1);
 var dow = d.getDay();
 if (dow !== 0 && dow !== 6) added++;
 }
 return d;
 }
 function zmzmFmtDate(d) {
 return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
 }

 // 1. Add delivery estimate under each cart item
 function zmzmCartDeliveryEstimate() {
 var now = new Date();
 // 1-2 business days to ship + 3-5 to deliver = 4-7 business days total
 var minDate = zmzmAddBusinessDays(now, 4);
 var maxDate = zmzmAddBusinessDays(now, 7);
 var label = 'Arrives ' + zmzmFmtDate(minDate) + ' – ' + zmzmFmtDate(maxDate);
 document.querySelectorAll('cart-item').forEach(function (item) {
 if (item.querySelector('.zmzm-delivery-estimate')) return;
 // Insert under name in the visible info block
 var info = item.querySelector('.cart-item__info:not(.cart-item__info--hide-mobile) .cart-item__name')
 || item.querySelector('.cart-item__info .cart-item__name')
 || item.querySelector('.cart-item__name');
 if (!info) return;
 var est = document.createElement('div');
 est.className = 'zmzm-delivery-estimate';
 est.innerHTML = '<span>' + label + '</span>';
 // Insert after the name
 var parent = info.parentNode;
 if (info.nextSibling) parent.insertBefore(est, info.nextSibling);
 else parent.appendChild(est);
 });
 }

 // 2. Stock urgency badge on PDP
 function zmzmStockUrgency() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-stock-urgency')) return;
 // Astra exposes inventory_quantity in the cart-item data and via product JSON
 var dataEl = document.querySelector('[id^="ProductJson-"], script[type="application/json"][data-product-json]');
 var inventory = null;
 if (dataEl) {
 try {
 var pdata = JSON.parse(dataEl.textContent);
 var variant = (pdata.variants || [])[0];
 if (variant && variant.inventory_quantity !== undefined) inventory = variant.inventory_quantity;
 if (variant && variant.inventory_management === null) return; // not tracked
 } catch (e) {}
 }
 // Fallback: read from inventory-status component
 if (inventory === null) {
 var invEl = document.querySelector('[data-stock-quantity], [data-inventory-quantity]');
 if (invEl) {
 var attr = invEl.getAttribute('data-stock-quantity') || invEl.getAttribute('data-inventory-quantity');
 var n = parseInt(attr, 10);
 if (!isNaN(n)) inventory = n;
 }
 }
 if (inventory === null || inventory > 5 || inventory <= 0) return;
 // Insert urgency badge near price
 var anchor = document.querySelector('[class*="product-info"] [class*="price"], product-info [class*="price"], .product__price, .price-wrap');
 if (!anchor) return;
 var badge = document.createElement('div');
 badge.className = 'zmzm-stock-urgency';
 badge.textContent = 'Only ' + inventory + ' left in stock';
 anchor.parentNode.insertBefore(badge, anchor.nextSibling);
 }

 function zmzmRunFinalPolish() {
 zmzmCartDeliveryEstimate();
 zmzmStockUrgency();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunFinalPolish);
 } else {
 zmzmRunFinalPolish();
 }
 ['cart:updated', 'cart-drawer:opened', 'shopify:section:load', 'variant:changed'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunFinalPolish, 80); });
 });


 /* === ZMZM PDP polish JS (May 6, 2026): order-by countdown, trust strip injection === */

 // 1. Order-by-X countdown — drives same-day shipping urgency
 // Cutoff: 2pm Central Time (UTC-6 standard, UTC-5 daylight). Use America/Chicago.
 function zmzmOrderByBadge() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-order-by')) return;
 var anchor = document.querySelector('product-form, [class*="product-form"], button[name="add"]');
 if (!anchor) return;
 var hostBlock = anchor.closest('product-form') || anchor.parentElement;

 function getCutoff() {
 // Get current Chicago time
 var now = new Date();
 var chicagoStr = now.toLocaleString('en-US', { timeZone: 'America/Chicago' });
 var chicagoNow = new Date(chicagoStr);
 var cutoff = new Date(chicagoNow);
 cutoff.setHours(14, 0, 0, 0); // 2:00 PM CT
 // If past cutoff, jump to next business day's cutoff
 if (chicagoNow >= cutoff || chicagoNow.getDay() === 0 || chicagoNow.getDay() === 6) {
 var next = new Date(chicagoNow);
 do {
 next.setDate(next.getDate() + 1);
 } while (next.getDay() === 0 || next.getDay() === 6);
 next.setHours(14, 0, 0, 0);
 return { cutoff: next, isToday: false };
 }
 return { cutoff: cutoff, isToday: true };
 }

 function fmtCountdown(ms) {
 var totalMin = Math.floor(ms / 60000);
 var h = Math.floor(totalMin / 60);
 var m = totalMin % 60;
 if (h <= 0 && m <= 0) return null;
 return h + 'h ' + m + 'm';
 }

 function render() {
 var info = getCutoff();
 var existing = document.querySelector('.zmzm-order-by');
 var nowChicago = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
 var diffMs = info.cutoff - nowChicago;

 var msg;
 if (info.isToday && diffMs > 0) {
 var cd = fmtCountdown(diffMs);
 if (!cd) return; // race past cutoff
 msg = 'order in <span class="zmzm-order-by__time">' + cd + '</span> for same-day shipping';
 } else {
 var dayName = info.cutoff.toLocaleDateString('en-US', { weekday: 'long' });
 msg = 'next ship-out: <span class="zmzm-order-by__time">' + dayName.toLowerCase() + ' 2pm ct</span>';
 }
 if (existing) {
 existing.innerHTML = msg;
 } else {
 var el = document.createElement('div');
 el.className = 'zmzm-order-by';
 el.innerHTML = msg;
 hostBlock.parentNode.insertBefore(el, hostBlock);
 }
 }
 render();
 // Update every minute
 setInterval(render, 60000);
 }

 // 2. PDP trust strip — three trust rows near ATC
 function zmzmPDPTrust() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-pdp-trust')) return;
 var anchor = document.querySelector('product-form, [class*="product-form"]');
 if (!anchor) return;
 var trust = document.createElement('div');
 trust.className = 'zmzm-pdp-trust';
 trust.innerHTML =
 '<div class="zmzm-pdp-trust__row"><span><strong>Free shipping</strong> on orders over $50</span></div>' +
 '<div class="zmzm-pdp-trust__row"><span><strong>30-day returns</strong> — no questions asked</span></div>' +
 '<div class="zmzm-pdp-trust__row"><span><strong>Halal Standards</strong> · third-party tested</span></div>';
 // Insert AFTER the product form so it sits below ATC
 if (anchor.nextSibling) anchor.parentNode.insertBefore(trust, anchor.nextSibling);
 else anchor.parentNode.appendChild(trust);
 }

 function zmzmRunPDPFinal() {
 zmzmOrderByBadge();
 zmzmPDPTrust();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunPDPFinal);
 } else {
 zmzmRunPDPFinal();
 }
 ['shopify:section:load', 'variant:changed'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunPDPFinal, 80); });
 });


 /* === ZMZM custom reviews widget (May 6, 2026) — Judge.me data baked in === */
 var ZMZM_REVIEWS = {"total": 290, "avg": 4.88, "reviews": [{"name": "Zainab S.", "rating": 5, "title": "Finally a truly Halal collagen!", "body": "I've been searching for a Halal grass-fed collagen for so long. This dissolves perfectly in my coffee and has no smell. My skin and nails are already showing improvement. So glad I found this brand.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Maryam Y.", "rating": 5, "title": "Finally a truly Halal collagen!", "body": "I've been searching for a Halal grass-fed collagen for so long. This dissolves perfectly in my coffee and has no smell. My skin and nails are already showing improvement. Honestly the best purchase.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Zainab P.", "rating": 5, "title": "Glass skin goals", "body": "This snail mucin is the real deal. It's hydrating and makes my skin look so dewy. Better than the more expensive brands. Clean ingredients.", "product": "Repair & Glow Mucin Serum", "verified": false}, {"name": "Hassan A.", "rating": 5, "title": "No more bloating!", "body": "I take two of these after lunch and it has completely fixed my digestion issues. Plus they taste like candy. Honestly the best purchase.", "product": "Apple Cider Vinegar (Vegan Capsules)", "verified": false}, {"name": "Zainab G.", "rating": 5, "title": "No more bloating!", "body": "I take two of these after lunch and it has completely fixed my digestion issues. Plus they taste like candy. So glad I found this brand.", "product": "Apple Cider Vinegar (Vegan Capsules)", "verified": false}, {"name": "Fatima W.", "rating": 5, "title": "Glass skin goals", "body": "This snail mucin is the real deal. It's hydrating and makes my skin look so dewy. Better than the more expensive brands. Will buy again!", "product": "Repair & Glow Mucin Serum", "verified": false}, {"name": "Ahmed N.", "rating": 5, "title": "No more bloating!", "body": "I take two of these after lunch and it has completely fixed my digestion issues. Plus they taste like candy. Honestly the best purchase.", "product": "Apple Cider Vinegar (Vegan Capsules)", "verified": false}, {"name": "Maryam O.", "rating": 5, "title": "Glass skin goals", "body": "This snail mucin is the real deal. It's hydrating and makes my skin look so dewy. Better than the more expensive brands. Will buy again!", "product": "Repair & Glow Mucin Serum", "verified": false}, {"name": "Hamza P.", "rating": 5, "title": "Amazing results", "body": "Since taking this, my hair shedding has decreased significantly. Such a relief to find a brand I can trust. So glad I found this brand.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Adam G.", "rating": 5, "title": "Amazing results", "body": "Since taking this, my hair shedding has decreased significantly. Such a relief to find a brand I can trust. Honestly the best purchase.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Rayyan A.", "rating": 5, "title": "Tasteless and effective", "body": "I mix it in my smoothies every morning. It doesn't change the flavor at all. Highly recommend ZMZM Labs. So glad I found this brand.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Ali J.", "rating": 5, "title": "Tasteless and effective", "body": "I mix it in my smoothies every morning. It doesn't change the flavor at all. Highly recommend ZMZM Labs. So glad I found this brand.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Amira G.", "rating": 5, "title": "Great for joints and skin", "body": "Started taking this for knee pain and I feel a noticeable difference. Love that it's pasture-raised and Halal. Packaging was great.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Ali A.", "rating": 5, "title": "Great for joints and skin", "body": "Started taking this for knee pain and I feel a noticeable difference. Love that it's pasture-raised and Halal. Clean ingredients.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Ali B.", "rating": 5, "title": "No more bloating!", "body": "I take two of these after lunch and it has completely fixed my digestion issues. Plus they taste like candy. Packaging was great.", "product": "Apple Cider Vinegar (Vegan Capsules)", "verified": false}, {"name": "Ibrahim T.", "rating": 5, "title": "Glass skin goals", "body": "This snail mucin is the real deal. It's hydrating and makes my skin look so dewy. Better than the more expensive brands. 5 stars.", "product": "Repair & Glow Mucin Serum", "verified": false}, {"name": "Hassan Z.", "rating": 5, "title": "Not greasy", "body": "I love that I can apply this and still style my hair. It doesn't weigh it down or make it look oily. Honestly the best purchase.", "product": "Root Revival Botanical Scalp Serum", "verified": false}, {"name": "Omar P.", "rating": 5, "title": "Great for joints and skin", "body": "Started taking this for knee pain and I feel a noticeable difference. Love that it's pasture-raised and Halal. Highly recommend.", "product": "Glow Collagen Peptides", "verified": false}, {"name": "Hamza K.", "rating": 5, "title": "No more bloating!", "body": "I take two of these after lunch and it has completely fixed my digestion issues. Plus they taste like candy. Clean ingredients.", "product": "Apple Cider Vinegar (Vegan Capsules)", "verified": false}, {"name": "Omar S.", "rating": 5, "title": "Amazing results", "body": "Since taking this, my hair shedding has decreased significantly. Such a relief to find a brand I can trust. Clean ingredients.", "product": "Glow Collagen Peptides", "verified": false}]};

 function zmzmStars(rating) {
 var s = '';
 for (var i = 0; i < 5; i++) s += i < rating ? '★' : '☆';
 return s;
 }
 function zmzmShuffle(arr) {
 var a = arr.slice();
 for (var i = a.length - 1; i > 0; i--) {
 var j = Math.floor(Math.random() * (i + 1));
 var t = a[i]; a[i] = a[j]; a[j] = t;
 }
 return a;
 }

 // 1. PDP — surface star rating near title + reviews section before related products
 function zmzmPDPReviews() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-reviews-section')) return;

 var data = ZMZM_REVIEWS;

 // 1a. Add inline rating summary near product title (if not already there from Judge.me badge)
 var title = document.querySelector('h1.product__title, [class*="product-title"]');
 if (title && !title.parentElement.querySelector('.zmzm-review-summary')) {
 var summary = document.createElement('div');
 summary.className = 'zmzm-review-summary';
 summary.innerHTML =
 '<span class="zmzm-review-summary__stars">' + zmzmStars(Math.round(data.avg)) + '</span>' +
 '<span class="zmzm-review-summary__rating">' + data.avg.toFixed(2) + '</span>' +
 '<span class="zmzm-review-summary__count">· ' + data.total + ' reviews</span>';
 title.parentElement.insertBefore(summary, title.nextSibling);
 }

 // 1b. Inject reviews section before related products / footer
 var anchor = document.querySelector('[id*="related-products"], [id*="recently-viewed"], #shopify-section-related-products, footer');
 if (!anchor) return;

 function pickReviews(n) {
 return zmzmShuffle(data.reviews).slice(0, n);
 }

 function buildSection() {
 var picks = pickReviews(5);
 var cards = picks.map(function (r) {
 var titleHtml = r.title ? '<h4 class="zmzm-review-card__title">' + escapeHtml(r.title) + '</h4>' : '';
 var productHtml = r.product ? '<span class="zmzm-review-card__meta-product"> · ' + escapeHtml(r.product) + '</span>' : '';
 return '<div class="zmzm-review-card">' +
 '<div class="zmzm-review-card__top">' +
 '<span class="zmzm-review-card__stars">' + zmzmStars(r.rating) + '</span>' +
 '<span class="zmzm-review-card__verified">Verified buyer</span>' +
 '</div>' +
 titleHtml +
 '<p class="zmzm-review-card__body">' + escapeHtml(r.body) + '</p>' +
 '<div class="zmzm-review-card__meta">— ' + escapeHtml(r.name) + productHtml + '</div>' +
 '</div>';
 }).join('');

 return '<section class="zmzm-reviews-section">' +
 '<div class="zmzm-reviews-section__head">' +
 '<h3 class="zmzm-reviews-section__title">what customers say</h3>' +
 '<div class="zmzm-reviews-section__big-rating">' +
 '<strong>' + data.avg.toFixed(2) + '</strong>' +
 '<span class="stars">' + zmzmStars(Math.round(data.avg)) + '</span>' +
 '<span>' + data.total + ' verified reviews</span>' +
 '</div>' +
 '</div>' +
 cards +
 '<div class="zmzm-reviews-section__refresh"><button type="button" data-zmzm-shuffle>Show different reviews</button></div>' +
 '</section>';
 }

 var section = document.createElement('div');
 section.innerHTML = buildSection();
 var sectionEl = section.firstElementChild;
 anchor.parentNode.insertBefore(sectionEl, anchor);

 // Shuffle button
 sectionEl.addEventListener('click', function (e) {
 if (e.target.matches('[data-zmzm-shuffle]')) {
 var fresh = document.createElement('div');
 fresh.innerHTML = buildSection();
 sectionEl.parentNode.replaceChild(fresh.firstElementChild, sectionEl);
 sectionEl = fresh.firstElementChild;
 }
 });
 }

 // 2. Cart drawer — small rotating testimonial above CHECK OUT
 function zmzmCartTestimonial() {
 var data = ZMZM_REVIEWS;
 var btns = document.querySelectorAll('button[name="checkout"], .cart-drawer-subtotal__btn');
 btns.forEach(function (btn) {
 var host = btn.closest('.cart-drawer-subtotal, [class*="cart-totals"]') || btn.parentElement;
 if (!host) return;
 // Insert testimonial above the trust strip we already inject
 var trust = host.querySelector('.zmzm-cart-trust');
 if (host.querySelector('.zmzm-cart-testimonial')) return;
 var pick = data.reviews[Math.floor(Math.random() * data.reviews.length)];
 var tEl = document.createElement('div');
 tEl.className = 'zmzm-cart-testimonial';
 tEl.innerHTML =
 '<p class="zmzm-cart-testimonial__quote">"' + escapeHtml((pick.body || '').slice(0, 120)) + (pick.body && pick.body.length > 120 ? '…' : '') + '"</p>' +
 '<div class="zmzm-cart-testimonial__attr">— ' + escapeHtml(pick.name) + ' · ★★★★★</div>';
 var anchor = trust || btn;
 host.insertBefore(tEl, anchor);
 });
 }

 // Helper
 function escapeHtml(s) {
 if (!s) return '';
 return String(s).replace(/[&<>"']/g, function (c) {
 return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
 });
 }

 function zmzmRunReviewsWidget() {
 zmzmPDPReviews();
 zmzmCartTestimonial();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunReviewsWidget);
 } else {
 zmzmRunReviewsWidget();
 }
 ['cart:updated', 'cart-drawer:opened', 'shopify:section:load'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunReviewsWidget, 100); });
 });


 /* === ZMZM reviews v2 (May 6, 2026): cart trust rating, verified badge === */

 // Update cart trust strip to include shop-level rating
 function zmzmCartTrustRating() {
 document.querySelectorAll('.zmzm-cart-trust').forEach(function (strip) {
 if (strip.querySelector('.zmzm-cart-trust__pill--rating')) return;
 var pill = document.createElement('span');
 pill.className = 'zmzm-cart-trust__pill zmzm-cart-trust__pill--rating';
 var data = (typeof ZMZM_REVIEWS === 'object' && ZMZM_REVIEWS) ? ZMZM_REVIEWS : { avg: 4.88, total: 290 };
 pill.textContent = data.avg.toFixed(2) + ' · ' + data.total + ' reviews';
 // Insert as second item (after Free Shipping)
 var firstChild = strip.children[1] || strip.firstChild;
 strip.insertBefore(pill, firstChild);
 });
 }

 // Verified badge — show on PDP near review summary if THIS product has linked reviews (≥10)
 // Detection: read product.metafields.reviews.rating_count from the rendered JSON-LD or DOM
 function zmzmVerifiedBadge() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-verified-badge')) return;
 var summary = document.querySelector('.zmzm-review-summary');
 if (!summary) return;
 // Try to find a product-specific review count from the page
 // Astra emits Product JSON-LD with aggregateRating when metafield is set
 var ratingCount = null;
 document.querySelectorAll('script[type="application/ld+json"]').forEach(function (s) {
 try {
 var d = JSON.parse(s.textContent);
 if (d['@type'] === 'Product' && d.aggregateRating && d.aggregateRating.reviewCount) {
 ratingCount = parseInt(d.aggregateRating.reviewCount, 10);
 }
 } catch (e) {}
 });
 if (!ratingCount || ratingCount < 10) return;
 var badge = document.createElement('span');
 badge.className = 'zmzm-verified-badge';
 badge.textContent = ratingCount + ' verified buyers';
 summary.appendChild(badge);
 }

 function zmzmRunReviewsV2() {
 zmzmCartTrustRating();
 zmzmVerifiedBadge();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunReviewsV2);
 } else {
 zmzmRunReviewsV2();
 }
 ['cart:updated', 'cart-drawer:opened', 'shopify:section:load'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunReviewsV2, 100); });
 });


 /* === ZMZM blue polish JS (May 7, 2026): mobile bottom-nav + qty nudge === */

 // 1. Mobile bottom-nav injection — Shop / Quiz / Search / Cart
 function zmzmMobileNav() {
 if (document.querySelector('.zmzm-mobile-nav')) return;
 if (window.innerWidth > 768) return;

 var nav = document.createElement('nav');
 nav.className = 'zmzm-mobile-nav';
 nav.setAttribute('aria-label', 'Mobile navigation');

 var iconShop = '<svg class="zmzm-mobile-nav__icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" /></svg>';
 var iconQuiz = '<svg class="zmzm-mobile-nav__icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" /></svg>';
 var iconSearch = '<svg class="zmzm-mobile-nav__icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" /></svg>';
 var iconCart = '<svg class="zmzm-mobile-nav__icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" /></svg>';

 nav.innerHTML =
 '<a class="zmzm-mobile-nav__item" href="/collections/all-products">' + iconShop + '<span>shop</span></a>' +
 '<a class="zmzm-mobile-nav__item" href="/pages/barakah-quiz">' + iconQuiz + '<span>quiz</span></a>' +
 '<a class="zmzm-mobile-nav__item" href="/search" data-zmzm-search>' + iconSearch + '<span>search</span></a>' +
 '<a class="zmzm-mobile-nav__item" href="/cart" data-zmzm-cart>' + iconCart + '<span>cart</span><span class="zmzm-mobile-nav__badge" data-zmzm-cart-count style="display:none">0</span></a>';

 document.body.appendChild(nav);

 // Update cart count badge from /cart.js
 function updateCartBadge() {
 fetch('/cart.js', { credentials: 'same-origin' })
 .then(function (r) { return r.json(); })
 .then(function (cart) {
 var badge = nav.querySelector('[data-zmzm-cart-count]');
 if (!badge) return;
 var count = cart.item_count || 0;
 badge.textContent = count;
 badge.style.display = count > 0 ? 'inline-block' : 'none';
 })
 .catch(function () {});
 }
 updateCartBadge();
 document.addEventListener('cart:updated', updateCartBadge);

 // Hijack search link to open existing search drawer if present
 var searchLink = nav.querySelector('[data-zmzm-search]');
 if (searchLink) {
 searchLink.addEventListener('click', function (e) {
 var existingTrigger = document.querySelector('[data-search-trigger], button[aria-label*="earch" i], a[href="/search"]:not([data-zmzm-search])');
 if (existingTrigger && existingTrigger !== searchLink) {
 e.preventDefault();
 existingTrigger.click();
 }
 });
 }

 // Hijack cart link to open existing cart drawer
 var cartLink = nav.querySelector('[data-zmzm-cart]');
 if (cartLink) {
 cartLink.addEventListener('click', function (e) {
 var drawerTrigger = document.querySelector('[data-cart-drawer-trigger], a[href="/cart"][class*="header"]:not([data-zmzm-cart])');
 if (drawerTrigger && drawerTrigger !== cartLink) {
 e.preventDefault();
 drawerTrigger.click();
 }
 });
 }
 }

 // 2. Quantity discount nudge — placeholder messaging on cart line items > 1
 // (No actual discount automation — this is informational; real discounts come from Shopify)
 function zmzmQtyNudge() {
 var items = document.querySelectorAll('cart-item[data-quantity]');
 items.forEach(function (item) {
 var qty = parseInt(item.dataset.quantity || '0', 10);
 if (qty < 2) return;
 if (item.querySelector('.zmzm-qty-nudge')) return;
 var msg;
 if (qty === 2) {
 msg = '<strong>Stocked up.</strong> Subscribe &amp; save up to 25% if you want auto-refill.';
 } else {
 msg = '<strong>Bulk move.</strong> Share with friends — refer them and earn store credit.';
 }
 var nudge = document.createElement('div');
 nudge.className = 'zmzm-qty-nudge';
 nudge.innerHTML = msg;
 var details = item.querySelector('.cart-item__info, .cart-item__details');
 if (details) details.appendChild(nudge);
 });
 }

 function zmzmRunBlue() {
 zmzmMobileNav();
 zmzmQtyNudge();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunBlue);
 } else {
 zmzmRunBlue();
 }
 ['cart:updated', 'cart-drawer:opened', 'shopify:section:load'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunBlue, 80); });
 });


 /* === ZMZM loyalty pack JS (May 7, 2026): wishlist + reorder === */

 // ───────── 1. WISHLIST ─────────
 var ZMZM_WISHLIST_KEY = 'zmzm_wishlist_v1';

 function zmzmWlGet() {
 try { return JSON.parse(localStorage.getItem(ZMZM_WISHLIST_KEY) || '[]'); }
 catch (e) { return []; }
 }
 function zmzmWlSet(list) {
 try { localStorage.setItem(ZMZM_WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
 document.dispatchEvent(new CustomEvent('zmzm:wishlist:updated'));
 }
 function zmzmWlHas(handle) {
 return zmzmWlGet().some(function (i) { return i.handle === handle; });
 }
 function zmzmWlToggle(item) {
 var list = zmzmWlGet();
 var ix = list.findIndex(function (i) { return i.handle === item.handle; });
 if (ix >= 0) list.splice(ix, 1);
 else list.unshift(item);
 if (list.length > 50) list.length = 50;
 zmzmWlSet(list);
 return ix < 0; // true = added, false = removed
 }

 var HEART_SVG = '<svg class="zmzm-wishlist-btn__icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" /></svg>';
 var HEART_FILLED = '<svg class="zmzm-wishlist-btn__icon" fill="currentColor" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24"><path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" /></svg>';

 // 1a. Inject heart button on PDP
 function zmzmWlPDPButton() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-wishlist-btn--pdp')) return;
 var m = location.pathname.match(/\/products\/([^\/?]+)/);
 if (!m) return;
 var handle = m[1];
 var titleEl = document.querySelector('h1.product__title, [class*="product-title"]');
 var imgEl = document.querySelector('.product__media img, [class*="product-media"] img, [class*="product-image"] img');
 var item = {
 handle: handle,
 title: titleEl ? titleEl.textContent.trim() : handle,
 image: imgEl ? (imgEl.currentSrc || imgEl.src) : ''
 };
 var anchor = document.querySelector('product-form, [class*="product-form"]');
 if (!anchor) return;
 var btn = document.createElement('button');
 btn.type = 'button';
 btn.className = 'zmzm-wishlist-btn zmzm-wishlist-btn--pdp';
 btn.setAttribute('aria-pressed', zmzmWlHas(handle) ? 'true' : 'false');
 btn.innerHTML = (zmzmWlHas(handle) ? HEART_FILLED : HEART_SVG) + '<span>' + (zmzmWlHas(handle) ? 'Saved' : 'Save for later') + '</span>';
 btn.addEventListener('click', function () {
 var added = zmzmWlToggle(item);
 btn.setAttribute('aria-pressed', added ? 'true' : 'false');
 btn.innerHTML = (added ? HEART_FILLED : HEART_SVG) + '<span>' + (added ? 'Saved' : 'Save for later') + '</span>';
 });
 anchor.parentNode.insertBefore(btn, anchor.nextSibling);
 }

 // 1b. Inject heart button on each product card
 function zmzmWlCardButtons() {
 document.querySelectorAll('[class*="product-card"]').forEach(function (card) {
 if (card.querySelector('.zmzm-wishlist-btn--card')) return;
 var link = card.querySelector('a[href*="/products/"]');
 if (!link) return;
 var m = link.getAttribute('href').match(/\/products\/([^\/?]+)/);
 if (!m) return;
 var handle = m[1];
 var titleEl = card.querySelector('[class*="product-card__name"], [class*="product-card__title"]');
 var imgEl = card.querySelector('img');
 var item = {
 handle: handle,
 title: titleEl ? titleEl.textContent.trim() : handle,
 image: imgEl ? (imgEl.currentSrc || imgEl.src) : ''
 };
 var btn = document.createElement('button');
 btn.type = 'button';
 btn.className = 'zmzm-wishlist-btn zmzm-wishlist-btn--card';
 btn.setAttribute('aria-label', 'Save to wishlist');
 btn.setAttribute('aria-pressed', zmzmWlHas(handle) ? 'true' : 'false');
 btn.innerHTML = zmzmWlHas(handle) ? HEART_FILLED : HEART_SVG;
 btn.addEventListener('click', function (e) {
 e.preventDefault();
 e.stopPropagation();
 var added = zmzmWlToggle(item);
 btn.setAttribute('aria-pressed', added ? 'true' : 'false');
 btn.innerHTML = added ? HEART_FILLED : HEART_SVG;
 });
 card.appendChild(btn);
 });
 }

 // 1c. Wishlist drawer (open via mobile-nav heart icon if added)
 function zmzmWlBuildDrawer() {
 if (document.querySelector('.zmzm-wishlist-drawer')) return;
 var drawer = document.createElement('aside');
 drawer.className = 'zmzm-wishlist-drawer';
 drawer.setAttribute('aria-label', 'Wishlist');
 document.body.appendChild(drawer);
 return drawer;
 }
 function zmzmWlRenderDrawer() {
 var drawer = zmzmWlBuildDrawer();
 if (!drawer) return;
 var items = zmzmWlGet();
 var listHtml = items.length === 0
 ? '<div class="zmzm-wishlist-drawer__empty">No saved items yet. Tap the heart on any product to save it.</div>'
 : '<ul class="zmzm-wishlist-drawer__list">' + items.map(function (item) {
 return '<li class="zmzm-wishlist-drawer__item">' +
 (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<div></div>') +
 '<a class="zmzm-wishlist-drawer__item-title" href="/products/' + escapeHtml(item.handle) + '">' + escapeHtml(item.title) + '</a>' +
 '<button type="button" class="zmzm-wishlist-drawer__item-remove" data-zmzm-wl-remove="' + escapeHtml(item.handle) + '">remove</button>' +
 '</li>';
 }).join('') + '</ul>';
 drawer.innerHTML =
 '<div class="zmzm-wishlist-drawer__head">' +
 '<h2 class="zmzm-wishlist-drawer__title">saved for later</h2>' +
 '<button class="zmzm-wishlist-drawer__close" aria-label="Close" data-zmzm-wl-close>×</button>' +
 '</div>' +
 listHtml;

 drawer.querySelector('[data-zmzm-wl-close]').addEventListener('click', function () {
 drawer.classList.remove('zmzm-wishlist-drawer--open');
 });
 drawer.querySelectorAll('[data-zmzm-wl-remove]').forEach(function (b) {
 b.addEventListener('click', function () {
 var handle = b.getAttribute('data-zmzm-wl-remove');
 var list = zmzmWlGet().filter(function (i) { return i.handle !== handle; });
 zmzmWlSet(list);
 zmzmWlRenderDrawer();
 // Refresh hearts on cards
 document.querySelectorAll('.zmzm-wishlist-btn[aria-pressed]').forEach(function (btn) {
 var card = btn.closest('[class*="product-card"]');
 if (card) {
 var link = card.querySelector('a[href*="/products/' + handle + '"]');
 if (link) {
 btn.setAttribute('aria-pressed', 'false');
 btn.innerHTML = HEART_SVG;
 }
 }
 });
 });
 });
 }
 function zmzmWlOpen() {
 zmzmWlRenderDrawer();
 var d = document.querySelector('.zmzm-wishlist-drawer');
 if (d) d.classList.add('zmzm-wishlist-drawer--open');
 }

 // 1d. Add wishlist link to mobile bottom-nav (replace search if there's no search drawer)
 function zmzmWlAddNavLink() {
 var nav = document.querySelector('.zmzm-mobile-nav');
 if (!nav) return;
 if (nav.querySelector('[data-zmzm-wl-trigger]')) return;
 // Replace the search button (which is somewhat redundant) with wishlist
 var searchItem = nav.querySelector('[data-zmzm-search]');
 if (searchItem) {
 searchItem.setAttribute('data-zmzm-wl-trigger', 'true');
 searchItem.removeAttribute('href');
 searchItem.style.cursor = 'pointer';
 searchItem.innerHTML =
 '<svg class="zmzm-mobile-nav__icon" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" /></svg>' +
 '<span>saved</span>';
 // Replace listener
 var clone = searchItem.cloneNode(true);
 searchItem.parentNode.replaceChild(clone, searchItem);
 clone.addEventListener('click', function (e) { e.preventDefault(); zmzmWlOpen(); });
 }
 }

 // ───────── 2. REORDER ─────────
 // For logged-in customers on /account or /account/orders, add a "Reorder last" card
 function zmzmReorderCard() {
 var path = location.pathname;
 if (!/^\/account(\/orders\/?)?$/.test(path)) return;
 if (document.querySelector('.zmzm-reorder-card')) return;
 // Try to find the last order link
 var lastOrderLink = document.querySelector('a[href*="/account/orders/"]');
 if (!lastOrderLink) return;
 var card = document.createElement('div');
 card.className = 'zmzm-reorder-card';
 card.innerHTML =
 '<p class="zmzm-reorder-card__heading">welcome back</p>' +
 '<h3 class="zmzm-reorder-card__title">stick to your routine?</h3>' +
 '<button type="button" class="zmzm-reorder-card__btn" data-zmzm-reorder>Reorder my last order</button>';
 var anchor = document.querySelector('main, [class*="account__heading"], h1') || document.body;
 anchor.parentNode.insertBefore(card, anchor.nextSibling);

 card.querySelector('[data-zmzm-reorder]').addEventListener('click', function () {
 var btn = card.querySelector('[data-zmzm-reorder]');
 btn.disabled = true;
 btn.textContent = 'Adding to cart...';
 // Use Shopify's order_id from URL (assumption: most recent order link in DOM)
 var orderUrl = lastOrderLink.getAttribute('href');
 // Fetch the order page, parse line items by their handle
 fetch(orderUrl, { credentials: 'same-origin' })
 .then(function (r) { return r.text(); })
 .then(function (html) {
 var doc = new DOMParser().parseFromString(html, 'text/html');
 var variantInputs = doc.querySelectorAll('[data-variant-id], [data-product-variant-id]');
 var variantIds = [];
 variantInputs.forEach(function (el) {
 var vid = el.getAttribute('data-variant-id') || el.getAttribute('data-product-variant-id');
 if (vid) variantIds.push(parseInt(vid, 10));
 });
 if (!variantIds.length) {
 // Fallback: scan product links and prefill cart
 var productLinks = doc.querySelectorAll('a[href*="/products/"]');
 if (!productLinks.length) throw new Error('no items found');
 // Show user the order-status page
 location.href = orderUrl;
 return;
 }
 // POST to /cart/add.js
 return fetch('/cart/add.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({ items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }) })
 });
 })
 .then(function () { location.href = '/cart'; })
 .catch(function () {
 btn.disabled = false;
 btn.textContent = 'Reorder my last order';
 location.href = orderUrl;
 });
 });
 }

 function escapeHtml(s) {
 return String(s || '').replace(/[&<>"']/g, function (c) {
 return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
 });
 }

 function zmzmRunLoyalty() {
 zmzmWlPDPButton();
 zmzmWlCardButtons();
 zmzmWlAddNavLink();
 zmzmReorderCard();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunLoyalty);
 } else {
 zmzmRunLoyalty();
 }
 ['shopify:section:load', 'cart:updated'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunLoyalty, 80); });
 });


 /* === ZMZM predictive search (May 7, 2026) === */

 function zmzmSearchInit() {
 if (document.querySelector('.zmzm-search-overlay')) return;
 var overlay = document.createElement('div');
 overlay.className = 'zmzm-search-overlay';
 overlay.innerHTML =
 '<div class="zmzm-search-modal" role="dialog" aria-label="Search">' +
 '<div class="zmzm-search-modal__head">' +
 '<svg class="zmzm-search-modal__icon" fill="none" stroke="currentColor" stroke-width="1.6" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" /></svg>' +
 '<input type="search" class="zmzm-search-modal__input" placeholder="Search products..." aria-label="Search">' +
 '<button type="button" class="zmzm-search-modal__close" data-zmzm-search-close>esc</button>' +
 '</div>' +
 '<div class="zmzm-search-modal__results" data-zmzm-search-results></div>' +
 '</div>';
 document.body.appendChild(overlay);

 var input = overlay.querySelector('.zmzm-search-modal__input');
 var resultsBox = overlay.querySelector('[data-zmzm-search-results]');
 var modal = overlay.querySelector('.zmzm-search-modal');

 function close() {
 overlay.classList.remove('zmzm-search-overlay--open');
 input.value = '';
 resultsBox.innerHTML = '';
 }
 overlay.addEventListener('click', function (e) {
 if (e.target === overlay || e.target.matches('[data-zmzm-search-close]')) close();
 });
 document.addEventListener('keydown', function (e) {
 if (e.key === 'Escape' && overlay.classList.contains('zmzm-search-overlay--open')) close();
 });

 function escapeHtml(s) {
 return String(s || '').replace(/[&<>"']/g, function (c) {
 return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
 });
 }

 function fmtMoney(cents) {
 var n = parseFloat(cents) / 100;
 return '$' + n.toFixed(2);
 }

 var debounce;
 function search(q) {
 clearTimeout(debounce);
 if (!q || q.length < 2) { resultsBox.innerHTML = ''; return; }
 debounce = setTimeout(function () {
 var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
 fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
 .then(function (r) { return r.json(); })
 .then(function (d) {
 var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
 var colls = (d.resources && d.resources.results && d.resources.results.collections) || [];
 if (!prods.length && !colls.length) {
 resultsBox.innerHTML = '<div class="zmzm-search-modal__empty">No matches for "' + escapeHtml(q) + '"</div>';
 return;
 }
 var html = '';
 if (prods.length) {
 html += '<p class="zmzm-search-modal__section-label">Products</p>';
 prods.forEach(function (p) {
 var img = (p.image || '');
 html += '<a class="zmzm-search-result" href="' + escapeHtml(p.url || '/products/' + p.handle) + '">' +
 (img ? '<img src="' + escapeHtml(img) + '" alt="">' : '<div></div>') +
 '<h4 class="zmzm-search-result__title">' + escapeHtml(p.title) + '</h4>' +
 '<span class="zmzm-search-result__price">' + (p.price ? '$' + parseFloat(p.price).toFixed(2) : '') + '</span>' +
 '</a>';
 });
 }
 if (colls.length) {
 html += '<p class="zmzm-search-modal__section-label">Collections</p>';
 colls.forEach(function (c) {
 html += '<a class="zmzm-search-result" href="' + escapeHtml(c.url || '/collections/' + c.handle) + '">' +
 '<div></div>' +
 '<h4 class="zmzm-search-result__title">' + escapeHtml(c.title) + '</h4>' +
 '<span></span>' +
 '</a>';
 });
 }
 html += '<a class="zmzm-search-modal__view-all" href="/search?q=' + encodeURIComponent(q) + '">View all results →</a>';
 resultsBox.innerHTML = html;
 })
 .catch(function () {
 resultsBox.innerHTML = '<div class="zmzm-search-modal__empty">Search unavailable. Try the full search page.</div>';
 });
 }, 220);
 }
 input.addEventListener('input', function (e) { search(e.target.value); });

 // Hook all search triggers to open this modal
 function openSearchModal() {
 overlay.classList.add('zmzm-search-overlay--open');
 setTimeout(function () { input.focus(); }, 60);
 }
 // Find any existing search button/link and override
 document.querySelectorAll('a[href="/search"], button[aria-label*="earch" i], [data-search-trigger]').forEach(function (el) {
 if (el.dataset.zmzmSearchHooked) return;
 el.dataset.zmzmSearchHooked = 'true';
 el.addEventListener('click', function (e) {
 e.preventDefault();
 openSearchModal();
 });
 });

 // Also keyboard shortcut: Cmd/Ctrl+K
 document.addEventListener('keydown', function (e) {
 if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
 e.preventDefault();
 if (overlay.classList.contains('zmzm-search-overlay--open')) close();
 else openSearchModal();
 }
 });

 // Expose globally for the mobile-nav search button
 window.zmzmOpenSearch = openSearchModal;
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmSearchInit);
 } else {
 zmzmSearchInit();
 }


 /* === ZMZM bundle (May 6, 2026): review wall + exit popup === */

 // 1. Homepage review wall — 3-column grid above founder note
 function zmzmReviewWall() {
 if (!document.body.classList.contains('template-index')) return;
 if (document.querySelector('.zmzm-review-wall')) return;
 if (typeof ZMZM_REVIEWS !== 'object' || !ZMZM_REVIEWS) return;

 var anchor = document.querySelector('[id*="zmzm_founder_note"], [id*="zmzm-founder-note"], [id*="founder-note"]');
 if (!anchor) {
 anchor = document.querySelector('main > *:nth-child(4), main > *:last-child');
 }
 if (!anchor) return;

 function pickReviews(n) {
 var pool = ZMZM_REVIEWS.reviews.slice();
 // Prefer ones with title and varied
 pool.sort(function () { return Math.random() - 0.5; });
 return pool.slice(0, n);
 }

 function escapeHtml(s) {
 return String(s || '').replace(/[&<>"']/g, function (c) {
 return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
 });
 }

 function buildStars(n) {
 var s = '';
 for (var i = 0; i < 5; i++) s += i < n ? '★' : '☆';
 return s;
 }

 var picks = pickReviews(6);
 var cards = picks.map(function (r) {
 var title = r.title ? '<h4 class="zmzm-review-wall__card-title">' + escapeHtml(r.title) + '</h4>' : '';
 return '<article class="zmzm-review-wall__card">' +
 '<div class="zmzm-review-wall__card-stars">' + buildStars(r.rating) + '</div>' +
 title +
 '<p class="zmzm-review-wall__card-body">"' + escapeHtml(r.body) + '"</p>' +
 '<div class="zmzm-review-wall__card-meta">— ' + escapeHtml(r.name) + (r.product ? ' · ' + escapeHtml(r.product) : '') + '</div>' +
 '</article>';
 }).join('');

 var section = document.createElement('section');
 section.className = 'zmzm-review-wall';
 section.innerHTML =
 '<div class="zmzm-review-wall__head">' +
 '<div class="zmzm-review-wall__eyebrow">verified buyers</div>' +
 '<h2 class="zmzm-review-wall__title">trusted by 290+ customers</h2>' +
 '<div class="zmzm-review-wall__rating">' +
 '<span class="stars">' + buildStars(Math.round(ZMZM_REVIEWS.avg)) + '</span>' +
 '<strong>' + ZMZM_REVIEWS.avg.toFixed(2) + '</strong>' +
 '<span>average rating · ' + ZMZM_REVIEWS.total + ' reviews</span>' +
 '</div>' +
 '</div>' +
 '<div class="zmzm-review-wall__grid">' + cards + '</div>';

 anchor.parentNode.insertBefore(section, anchor);
 }

 // 2. Exit-intent / scroll popup
 function zmzmExitIntentPopup() {
 if (sessionStorage.getItem('zmzm_popup_shown')) return;
 if (localStorage.getItem('zmzm_popup_dismissed')) return;
 if (document.querySelector('.zmzm-popup-overlay')) return;

 function showPopup() {
 if (sessionStorage.getItem('zmzm_popup_shown')) return;
 sessionStorage.setItem('zmzm_popup_shown', '1');

 var overlay = document.createElement('div');
 overlay.className = 'zmzm-popup-overlay';
 overlay.innerHTML =
 '<div class="zmzm-popup" role="dialog" aria-modal="true" aria-labelledby="zmzmPopupTitle">' +
 '<button class="zmzm-popup__close" aria-label="Close" data-zmzm-close>×</button>' +
 '<div class="zmzm-popup__eyebrow">first-time visitor</div>' +
 '<h3 class="zmzm-popup__title" id="zmzmPopupTitle">save 20% on your first order</h3>' +
 '<p class="zmzm-popup__body">Halal, third-party tested, designed around your daily rhythm. Drop your email — we\'ll send your code.</p>' +
 '<form class="zmzm-popup__form" action="/contact#contact_form" method="post" accept-charset="UTF-8">' +
 '<input type="hidden" name="form_type" value="customer">' +
 '<input type="hidden" name="utf8" value="✓">' +
 '<input type="hidden" name="contact[tags]" value="popup-signup,welcome20">' +
 '<input type="email" name="contact[email]" placeholder="your@email.com" required autocomplete="email">' +
 '<button type="submit">Get my 20% code</button>' +
 '<button type="button" class="zmzm-popup__skip" data-zmzm-close>no thanks, I prefer paying full price</button>' +
 '</form>' +
 '</div>';
 document.body.appendChild(overlay);
 requestAnimationFrame(function () {
 overlay.classList.add('zmzm-popup-overlay--visible');
 });

 function close() {
 overlay.classList.remove('zmzm-popup-overlay--visible');
 setTimeout(function () { overlay.remove(); }, 320);
 }

 overlay.addEventListener('click', function (e) {
 if (e.target === overlay || e.target.matches('[data-zmzm-close]')) close();
 });

 // Submit: show success + remember
 overlay.querySelector('form').addEventListener('submit', function (e) {
 // Allow native submit (Shopify customer create) but show success + close after a moment
 localStorage.setItem('zmzm_popup_dismissed', '1');
 setTimeout(close, 500);
 });

 // ESC to close
 document.addEventListener('keydown', function escHandler(e) {
 if (e.key === 'Escape') {
 close();
 document.removeEventListener('keydown', escHandler);
 }
 });
 }

 // Trigger 1: mouse-leave-to-close (desktop only)
 var mouseLeftOnce = false;
 if (window.innerWidth > 768) {
 document.addEventListener('mouseleave', function (e) {
 if (mouseLeftOnce) return;
 if (e.clientY < 5 && !sessionStorage.getItem('zmzm_popup_shown')) {
 mouseLeftOnce = true;
 showPopup();
 }
 });
 }

 // Trigger 2: scroll past 60% of page (mobile + desktop fallback)
 var scrollFired = false;
 function onScroll() {
 if (scrollFired || sessionStorage.getItem('zmzm_popup_shown')) return;
 var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
 if (pct > 0.60) {
 scrollFired = true;
 showPopup();
 window.removeEventListener('scroll', onScroll);
 }
 }
 window.addEventListener('scroll', onScroll, { passive: true });

 // Trigger 3: 30 seconds on page (failsafe)
 setTimeout(function () {
 if (!sessionStorage.getItem('zmzm_popup_shown')) showPopup();
 }, 30000);
 }

 function zmzmRunBundle() {
 zmzmReviewWall();
 zmzmExitIntentPopup();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunBundle);
 } else {
 zmzmRunBundle();
 }


 /* === ZMZM final bundle (May 6, 2026): FBT, recent, hero priority === */

 // 1. Frequently bought together — pull 2 products with overlapping tags
 function zmzmFBT() {
 if (!document.body.classList.contains('template-product')) return;
 if (document.querySelector('.zmzm-fbt')) return;
 var pid = (document.querySelector('[data-product-id]') || {}).dataset
 || (document.querySelector('product-info[data-product-id]') || {}).dataset;
 // Get current handle from URL
 var m = location.pathname.match(/\/products\/([^\/?]+)/);
 if (!m) return;
 var currentHandle = m[1];

 // Pull from /search/suggest — query a generic term + filter by tag overlap is hard
 // Easier: pull /collections/best-sellers/products.json and pick 2 NOT this one
 fetch('/collections/best-sellers/products.json?limit=10')
 .then(function (r) { return r.json(); })
 .then(function (d) {
 var picks = (d.products || []).filter(function (p) { return p.handle !== currentHandle; }).slice(0, 3);
 if (!picks.length) return;
 var section = document.createElement('section');
 section.className = 'zmzm-fbt';
 section.innerHTML =
 '<h3 class="zmzm-fbt__heading">Often paired with this</h3>' +
 '<div class="zmzm-fbt__grid">' +
 picks.map(function (p) {
 var img = (p.images || [])[0] || '';
 var price = p.variants && p.variants[0] ? p.variants[0].price : '';
 return '<a class="zmzm-fbt__card" href="/products/' + p.handle + '">' +
 (img ? '<img src="' + img + '" alt="' + (p.title || '') + '" loading="lazy">' : '') +
 '<h4 class="zmzm-fbt__card-title">' + escapeHtmlF(p.title) + '</h4>' +
 '<p class="zmzm-fbt__card-price">$' + price + '</p>' +
 '</a>';
 }).join('') +
 '</div>';
 var anchor = document.querySelector('[id*="related-products"], [id*="recently-viewed"], .zmzm-reviews-section, footer');
 if (anchor) anchor.parentNode.insertBefore(section, anchor);
 })
 .catch(function () {});

 function escapeHtmlF(s) {
 return String(s || '').replace(/[&<>"']/g, function (c) {
 return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
 });
 }
 }

 // 2. Recently viewed — localStorage tracker + carousel
 var ZMZM_RECENT_KEY = 'zmzm_recently_viewed_v1';
 function zmzmRecentTrack() {
 if (!document.body.classList.contains('template-product')) return;
 var m = location.pathname.match(/\/products\/([^\/?]+)/);
 if (!m) return;
 var handle = m[1];
 var titleEl = document.querySelector('h1.product__title, [class*="product-title"]');
 var imgEl = document.querySelector('.product__media img, [class*="product-media"] img, [class*="product-image"] img');
 var priceEl = document.querySelector('[class*="product-price"] [class*="price-item"]');
 var item = {
 handle: handle,
 title: titleEl ? titleEl.textContent.trim() : handle,
 image: imgEl ? imgEl.currentSrc || imgEl.src : '',
 price: priceEl ? priceEl.textContent.trim().split(/\s+/)[0] : '',
 ts: Date.now()
 };
 var list = [];
 try { list = JSON.parse(localStorage.getItem(ZMZM_RECENT_KEY) || '[]'); } catch (e) {}
 list = list.filter(function (i) { return i.handle !== handle; });
 list.unshift(item);
 if (list.length > 10) list.length = 10;
 try { localStorage.setItem(ZMZM_RECENT_KEY, JSON.stringify(list)); } catch (e) {}
 }

 function zmzmRecentRender() {
 if (document.querySelector('.zmzm-recent')) return;
 var list = [];
 try { list = JSON.parse(localStorage.getItem(ZMZM_RECENT_KEY) || '[]'); } catch (e) {}
 // On PDP, exclude current product
 var currentHandle = (location.pathname.match(/\/products\/([^\/?]+)/) || [])[1];
 var picks = list.filter(function (i) { return i.handle !== currentHandle; }).slice(0, 6);
 if (picks.length < 2) return; // not worth showing one item

 function escapeHtml(s) {
 return String(s || '').replace(/[&<>"']/g, function (c) {
 return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
 });
 }

 var section = document.createElement('section');
 section.className = 'zmzm-recent';
 section.innerHTML =
 '<div class="zmzm-recent__head"><h3 class="zmzm-recent__heading">Recently viewed</h3></div>' +
 '<div class="zmzm-recent__rail">' +
 picks.map(function (p) {
 return '<a class="zmzm-recent__card" href="/products/' + p.handle + '">' +
 (p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
 '<h4 class="zmzm-recent__card-title">' + escapeHtml(p.title) + '</h4>' +
 (p.price ? '<p class="zmzm-recent__card-price">' + escapeHtml(p.price) + '</p>' : '') +
 '</a>';
 }).join('') +
 '</div>';

 // Insert above footer / near bottom on PDP / collection
 var anchor = document.querySelector('[id*="related-products"], .zmzm-reviews-section, footer');
 if (anchor) anchor.parentNode.insertBefore(section, anchor);
 }

 // 3. Hero image priority — set fetchpriority high on first image-banner image
 function zmzmHeroPriority() {
 if (!document.body.classList.contains('template-index')) return;
 var firstHero = document.querySelector('[class*="image-banner"] img, [id*="image_banner"] img');
 if (firstHero && !firstHero.hasAttribute('fetchpriority')) {
 firstHero.setAttribute('fetchpriority', 'high');
 if (firstHero.getAttribute('loading') === 'lazy') {
 firstHero.setAttribute('loading', 'eager');
 }
 }
 }

 function zmzmRunFinalBundle() {
 zmzmFBT();
 zmzmRecentTrack();
 zmzmRecentRender();
 zmzmHeroPriority();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', zmzmRunFinalBundle);
 } else {
 zmzmRunFinalBundle();
 }
 ['shopify:section:load'].forEach(function (evt) {
 document.addEventListener(evt, function () { setTimeout(zmzmRunFinalBundle, 80); });
 });

})();

/* ── ZMZM Halal Tier badge injection ─────────────────────────── */
(function () {
 function injectTierBadge() {
 if (!window.zmzmTier || window.__zmzmTierInjected) return;
 var tier = String(window.zmzmTier).toLowerCase();
 if (tier !== 'certified' && tier !== 'friendly') return;

 // Find product title (h1 inside the main product section)
 var section = document.querySelector('[id^="shopify-section"][id*="__main"]') ||
 document.querySelector('main') || document.body;
 var titleEl = section.querySelector('h1');
 if (!titleEl || titleEl.parentNode.querySelector('.zmzm-tier-badge')) return;

 var label = tier === 'certified'
 ? 'ZMZM Labs · Halal'
 : 'ZMZM Labs · Halal';

 var why = tier === 'certified'
 ? 'Formulated to halal standards, verified in our lab and documented per batch.'
 : 'Curated and verified by ZMZM Labs in our internal lab. No external certifier; this is our process-trust tier.';

 var badge = document.createElement('span');
 badge.className = 'zmzm-tier-badge zmzm-tier-badge--' + tier;
 badge.setAttribute('data-zmzm-tier', tier);
 badge.textContent = label;

 var sub = document.createElement('p');
 sub.className = 'zmzm-tier-badge__why';
 sub.innerHTML = why + ' <a href="/pages/lab-reports">See our lab process.</a>';

 titleEl.parentNode.insertBefore(badge, titleEl);
 titleEl.parentNode.insertBefore(sub, titleEl.nextSibling);
 window.__zmzmTierInjected = true;
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', injectTierBadge);
 } else {
 injectTierBadge();
 }
 document.addEventListener('shopify:section:load', function () { setTimeout(injectTierBadge, 80); });
})();

/* ── ZMZM lazysizes safety net 2026-05-13 ─────────────────────────────
 Theme uses lazysizes + `opacity:0` placeholders on .lazyload images
 that only become visible once lazysizes adds `lazyloaded`. In some
 Chromium states (loading=lazy + src placeholder set) lazysizes
 doesn't unveil and images remain invisible. This safety net force-
 unveils any remaining lazyload images shortly after page load.
*/
(function () {
 function safeUnveilAll() {
 var imgs = document.querySelectorAll('img.lazyload');
 imgs.forEach(function (img) {
 try {
 var ds = img.getAttribute('data-srcset');
 var dsrc = img.getAttribute('data-src');
 if (ds && !img.getAttribute('srcset')) img.setAttribute('srcset', ds);
 if (dsrc && !img.src) img.src = dsrc;
 if (img.getAttribute('loading') === 'lazy') img.removeAttribute('loading');
 img.classList.remove('lazyload');
 img.classList.add('lazyloaded');
 if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
 window.lazySizes.loader.unveil(img);
 }
 } catch (e) { /* swallow per-image errors */ }
 });
 }
 function schedule() {
 // Run twice: once shortly after first paint, once after lazysizes had its chance
 setTimeout(safeUnveilAll, 400);
 setTimeout(safeUnveilAll, 1800);
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', schedule);
 } else {
 schedule();
 }
 document.addEventListener('shopify:section:load', function () { setTimeout(safeUnveilAll, 300); });
})();

/* ── ZMZM PDP H1 eyebrow injection ──────────────────────────
 Adds an above-H1 eyebrow that includes the "halal-{tier}" keyword,
 so on-page SEO matches the meta title + tier badge below the title.
 Runs once per PDP. Idempotent. */
(function () {
 function injectH1Eyebrow() {
 if (!window.zmzmTier || window.__zmzmH1Eyebrow) return;
 var section = document.querySelector('[id^="shopify-section"][id*="__main"]') || document.body;
 var titleEl = section.querySelector('h1');
 if (!titleEl) return;
 if (titleEl.parentNode.querySelector('.zmzm-h1-eyebrow')) {
 window.__zmzmH1Eyebrow = true;
 return;
 }
 var tier = String(window.zmzmTier).toLowerCase();
 var label = tier === 'certified'
 ? 'halal · halal-verified'
 : 'halal · wudu-safe · internally verified';
 var eyebrow = document.createElement('div');
 eyebrow.className = 'zmzm-h1-eyebrow';
 eyebrow.setAttribute('data-zmzm-tier', tier);
 eyebrow.textContent = label;
 titleEl.parentNode.insertBefore(eyebrow, titleEl);
 window.__zmzmH1Eyebrow = true;
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', injectH1Eyebrow);
 } else {
 injectH1Eyebrow();
 }
 document.addEventListener('shopify:section:load', function () { setTimeout(injectH1Eyebrow, 80); });
})();
